import React, { useState, useEffect, useRef } from 'react';
import Helper from './common/helper';
import Global from './common/global';
import ApiService from "./services/api.service";
import Header from './common/header';
import { Progress } from 'flowbite-react'
import LoadingScreen from './components/UI/loading-screen';
import StickyFooter from './components/UI/sticky-footer';
import ErrorComponent from './components/UI/error';
import { useNavigate } from "react-router-dom";
import TagManager from 'react-gtm-module';
import { phone } from 'phone';
import hasPostalCode from 'has-postalcode'
// import clsx from 'clsx';
import { 
  Phone, 
  Title, 
  Mail, 
  User,
  State, 
  Country, 
  Postcode, 
  City, 
  Home,
  // Help, 
} from './common/icons'
import {commissionJunctionRules} from "./common/commission-junction-rules"

// Steps Component
import ProductStep from './components/Steps/primary-product-step';                  //[Primary] Product
import SecondaryProductStep from './components/Steps/secondary-product-step';        //[Secondary] Product
import QbrEligibilityStep from './components/Steps/qbr-eligibility-step';
import PersonalDetailStep from './components/Steps/primary-personal-detail-step';   //[Primary] Details Step
import AddressStep from './components/Steps/primary-address-step';                  //[Primary] Address
import SecondaryPersonalDetailStep from './components/Steps/secondary-personal-detail-step';   //[Secondary] Details Step
import SecondaryAddressStep from './components/Steps/secondary-address-step';                  //[Secondary] Address
import ReviewStep from './components/Steps/review-step';
import PaymentStep from './components/Steps/payment-step';
import ConfirmationStep from './components/Steps/confirmation-step';
import ExploreStep from './components/Steps/explore-step';
import CTA from './components/UI/cta'
import languagesData from './assets/languages/languages.json';
// import UserStep from './components/Steps/user-step';


// const TERMS_CONDITIONS_LINK = 'https://www.accorplus.com/en-au/about/terms-and-conditions';
let QBR_JOIN_ERROR_MESSAGE = 'Something\'s not quite right and we\'re investigating. Please try again later. For assistance, contact the Qantas Business Rewards <a href="https://www.qantas.com/au/en/business-rewards/qbr/contactus" style="text-decoration-line:none" target="_blank">service desk</a>';


  TagManager.initialize({
    gtmId: Global.GTM_ID,
  });

const App = ({baseUrl}) => {
  let navigate = useNavigate(); 
  const queryParams = new URLSearchParams(window.location.search);
  
  // Globals
  const [step, setStep]                   = useState(1); // Wizard Step state
  const [progress, setProgress]           = useState(Helper.getProgressBarWidth(step)); // Progressbar State
  const [isProcessing, setIsProcessing]   = useState(false); // Button Footer Sticky state
  const [error, setError]                 = useState(null);
  const [emailChecking, setEmailChecking] = useState(false);
  const [isLoaded, setIsLoaded]           = useState(false); // isLoading
  const [locationDatas, setLocationData]  = useState([]); // get location Data - API
  const [allLanguages, setAllLanguages]   = useState([]); // get all Languages - API
  const [languages, setLanguages]         = useState([]); // get Languages on the basis country id - API
  const [couponData, setCouponData]       = useState([]); // get coupon Data
  const [isPrimaryDigitalCard, setIsPrimaryDigitalCard] = useState(false)
  const [isSecondaryDigitalCard, setIsSecondaryDigitalCard] = useState(false)
  const [headerText, setHeaderText]       = useState('');
  const [isQbr, setIsQbr] = useState(false);
  const countryList = Global.CODED_COUNTRY_LIST.map((item)=>{
    var country = item.name
    var code = item.code
    return {
      value: country, 
      text: country,
      code: code 
    }
  });

  const selectedCountry = Helper.lookupCurrentCountry().label;
  
  // [Step] - Products
  const [products, setProducts]               = useState([]); //product step
  const [isProductLoaded, setIsProductLoaded] = useState(false); // isLoading
  const [productError, setProductError]       = useState(null);

  // [Step] - Secondary Products
  const [secondaryProducts, setSecondaryMemberProducts] = useState([])
  const [isSecondaryMember, setIsSecondaryMember]       = useState(false)

  let locationDataCurrency = locationDatas.currency

  // check membership product data
  const [isProductLocalStored, setIsProductLocalStored] = useState(false)

  // Local Storage State
  const [localStorageDatas, setLocalStorageDatas] = useState({})

  // Header modal  
  const [showModal, setShowModal] = useState(false)

  // Member ID state - Confirm function
  const [memberId, setMemberId] = useState('')
  const [secondaryMemberId, setSecondaryMemberId] = useState('');

  const [memberCreationError, setMemberCreationError] = useState('');

  // SET businesscategories (BC)
  const [bc, setBC]              = useState({})
  // Set BC that we get from membership api
  const [businessCategories, setBusinessCategories] = useState({})
  const inputPersonalEl          = useRef([]);
  const inputSecondaryPersonalEl = useRef([]);

  const inputAddressEl        = useRef([]);
  const inputAddressBillingEl = useRef([]);

  const inputSecondaryAddressEl        = useRef([]);
  const inputSecondaryAddressBillingEl = useRef([]);

  // check if the input is touched
  const [touched, setTouched] = useState(false);

  // review-step refs
  const inputPromoEl = useRef([]);
  const readMeTerms = useRef(null);

  const [primaryPmid, setPrimaryPmid] = useState();

  // [Step] - Review Step
  function handleCardCheckBox(params, index, identifier) {
    let updatedProducts = localStorageDatas.members.map((item) => {  
      if(item.type_of_member === params.type_of_member && identifier === "primary") {
        setIsPrimaryDigitalCard(!item.card)
        return {
          ...item, 
          card: !item.card
        }
      } else if(item.type_of_member === params.type_of_member && identifier === "supp") {
        setIsSecondaryDigitalCard(!item.card)
        return {
          ...item, 
          card: !item.card
        }
      }else {
        return {
          ...item
        }
      }
    })
    setLocalStorageDatas(prevState => ({...prevState, ['members']: updatedProducts}));
  }

  function handleShowList(params, index) {
    let updatedProducts = localStorageDatas.members.map((item) => {      
      if(item.type_of_member === params.type_of_member) {
        return {
          ...item, isShown: !item.isShown
        }
      } else {
        return {
          ...item
        }
      }
    })
    setLocalStorageDatas(prevState => ({...prevState, ['members']: updatedProducts}))
  }

  // [Step] - Review Order - CheckboxTerms
  const [checkBoxTerms, setCheckBoxTerms] = useState(false);
  function handleCheckBoxTerms() {
    setCheckBoxTerms(!checkBoxTerms)
  }

  // [Footer][Step] 
  const [reviewLoading, setReviewLoading] = useState(false) // Review confirm Loading Button
  const [memberStatus, setMemberStatus]   = useState(false) //

  // [Adress][Primary]
  // const [addressInput, setAddressInput]                  = useState({});
  // const [billingAddressInput, setBillingAddressInput]    = useState({});
  const [checkboxAddress, setCheckboxAddress]            = useState(true);
  const [findMyaddessInGoogle , setFindMyaddessInGoogle] = useState(false);
  const [googleAddressEmpty , setGoogleAddressEmpty]     = useState(false);  

  // [Adress][Secondary]
  const [secondaryBillingAddressInput, setSecondaryBillingAddressInput]   = useState({});
  const [secondaryCheckboxAddress, setSecondaryCheckboxAddress]           = useState(true);
  const [secondaryFindMyaddessInGoogle, setSecondaryFindMyaddessInGoogle] = useState(false);
  const [secondaryGoogleAddressEmpty , setSecondaryGoogleAddressEmpty]    = useState(false);  

  // [Adress] - Primary
  const autoCompleteRef   = useRef();
  const autoCompleteRef2  = useRef();
  const inputRef          = useRef();
  const secondaryInputRef = useRef()
  const locationParam     = Helper.locationSelect();

  //check if user is logged in
  const [isUserLogged, setIsUserLogged]= useState(false)


  // [Primary] Personal Details
  const personalDetailsInputFields = [
    {
      name        : 'email',
      type        : 'email',
      placeholder : 'Email*',
      textHolder  : 'primaryEmail', 
      icon        : Mail,
      required    : true,
      value       : '',
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'confirm_email',
      type        : 'email',
      placeholder : 'Confirm Email*',      
      textHolder  : 'primaryConfirmEmail', 
      icon        : Mail,
      required    : true,
      value       : '',
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'title',
      type        : 'select',
      value       : 'Mr',
      placeholder : 'Title',
      textHolder  : 'primaryTitle', 
      icon        : Title,
      required    : false,
      isError     : false,
      message     :'',
      valid       : false,
      checking    : false,
      options     : Global.SALUTATION_LIST
    }, 
    {
      name        : 'first_name',
      type        : 'text',
      maxLength   : 25,
      placeholder : 'First Name*',
      textHolder  : 'primaryFirstName', 
      icon        : User,
      required    : true,
      value       : '',
      message     :'',
      isError     : false,
      valid       : false
    }, 
    {
      name        : 'last_name',
      type        : 'text',
      placeholder : 'Last Name*',
      textHolder  : 'primaryLastName', 
      maxLength   : 25,
      icon        : User,
      required    : true,
      value       : '',
      message     : '',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'phone_number',
      type        : 'tel',
      icon        : Phone,
      required    : true,
      value       : '',
      message     : '',
      isError     : false,
      valid       : false,
      checking    : false
    },    
    {
      name        : 'preferred_language',
      type        : 'select',
      options     : Global.PREFERRED_LANGUAGE,
      placeholder : 'Please select your preferred language.',
      textHolder  : 'preferredLanguage', 
      icon        : User,
      required    : false,
      value       : '',
      message     : '',
      isError     : false,
      valid       : false,
      checking    : false
    },
    {
      name        : 'tax_number',
      type        : 'num',
      placeholder : 'Tax Number',
      textHolder  : 'taxNumber', 
      icon        : Phone,
      required    : false,
      value       : '',
      message     : '',
      isError     : false,
      valid       : false,
      checking    : false
    }
  ]

  // [Secondary] Personal Details [1]
  const secondaryPersonalDetailsInputFields = [
    {
      name        : 'email',
      type        : 'email',
      placeholder : 'Email*',
      textHolder  : 'secondaryEmail', 
      icon        : Mail,
      required    : true,
      value       : '',
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'confirm_email',
      type        : 'email',
      placeholder : 'Confirm Email*',
      textHolder  : 'secondaryConfirmEmail', 
      icon        : Mail,
      required    : true,
      value       : '',
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'title',
      type        : 'select',
      value       : 'Mr',
      options     : Global.SALUTATION_LIST,
      placeholder : 'Title',
      textHolder  : 'secondaryTitle', 
      icon        : Title,
      required    : false,
      isError     : false,
      message     :'',
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'first_name',
      type        : 'text',
      maxLength   : 25,
      placeholder : 'First Name*',
      textHolder  : 'secondaryFirstName', 
      icon        : User,
      required    : true,
      value       : '',
      message     :'',
      isError     : false,
      valid       : false
    }, 
    {
      name        : 'last_name',
      type        : 'text',
      maxLength   : 25,
      placeholder : 'Last Name*',
      textHolder  : 'secondaryLastName', 
      icon        : User,
      required    : true,
      value       : '',
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'phone_number',
      type        : 'tel',
      placeholder : '+ 61*',
      icon        : Phone,
      required    : true,
      value       : '',
      message     : '',
      isError     : false,
      valid       : false,
      checking    : false
    },
    {
      name: 'tax_number',
      type: 'num',
      placeholder:  'Tax Number',
      textHolder  : 'taxNumber', 
      icon: Phone,
      required: false,
      value: '',
      message:'',
      isError: false,
      valid: false,
      checking: false
    },
  ]

  // [Primary] Initialize Personal Details
  const [inputFields, setInputFields] = useState(personalDetailsInputFields);
  
  // [Secondary] Initialize Secondary Personal Details [2]
  const [secondaryInputFields, setSecondaryInputFields] = useState(secondaryPersonalDetailsInputFields);
  
  // #cj state tracker  
  let commissionJunction = "";
  // Fetch language Json 
  useEffect (() => {
    fetchLanguages();    
    fetchLocationData(locationParam);
    // isSSOLoggedIn();
    setTouched(true)
    //getData()
    setProgress(Helper.getProgressBarWidth(step));
  }, []);

  // Load Product Data && Local Storage Data if exists
  // update when locationData is changed(loaded)
  useEffect(() => {    
    // isSSOLoggedIn();   
    if(isLoaded) {
      productData();
      getStoredProductData(products, 'selected_membership', 'primary');
      getStoredProductData(secondaryProducts, 'secondary_selected_membership', 'secondary');
      // getCountries()
    }
  }, [locationDatas]) 

  // Set Header Title and Get Local Storage Data
  // update when step is changed 
  useEffect(() => {
      // fetchLanguages();
      var currentStep = Helper.getSteps(step);
      const title     = Helper.getStepsTitle(currentStep, languages);
      setHeaderText(title);     
      setInputLanguages(setInputFields, inputFields, languages)
      setInputLanguages(setSecondaryInputFields, secondaryInputFields, languages)
      setInputLanguages(setPrimaryAddressInputFields, primaryAddressInputFields, languages)
      setInputLanguages(setSecondaryPrimaryAddressInputFields, primarySecondaryAddressInputFields, languages)
      setInputLanguages(setPrimaryBillingAddressInputFields, primaryBillingAddressInputFields, languages)
      setInputLanguages(setSecondaryPrimaryBilliingAddressInputFields, primarySecondaryBillingAddressInputFields, languages)
      // setHeaderStepText()
      if(step <= 9) {
        getLocalStorageDatas()
      }
      setProgress(Helper.getProgressBarWidth(step))    
      // if(inputFields) {
      //   checkMemberExist({"email": inputFields[0].value})
      // }
      // if(secondaryInputFields) {
      //   checkMemberExist({"email": secondaryInputFields[0].value})
      // }
  }, [step])


  useEffect(() => {
    if(step === 4) {
      inputPersonalEl.current['email'].focus()
    } else if (step === 6) {
      inputSecondaryPersonalEl.current['email'].focus()
    }
  }, [step])


  // Review terms and conditions button hover check
  function onMouseHover() {
    readMeTerms.current.classList.add('text-red')
  }

  function onMouseLeave() {
    readMeTerms.current.classList.remove('text-red')
  }

  function setInputLanguages(setLanguage, input, translation) {
    let region = locationParam.country.toLowerCase() || 'en_master';
    // if(region == 'ph' || region == 'in' || region == 'sg' || region == 'en') {
    if(region != 'th' || region != 'id' || region != 'vn') {
      region = 'en_master';
    }
    if(translation.length !== 0 && allLanguages[region].selectYourMembership !== '') {      
      let updatedPlaceholder = input.map((inputFields) => {
        if(inputFields.name) {
          return {
            ...inputFields,
            placeholder: translation[inputFields.textHolder]
          }
        } else {
          return {
            ...inputFields
          }
        }
      })
      setLanguage(updatedPlaceholder)
    } 
  }


  /**
   * Checking if the user is logged in to the SSO
   */
  async function isSSOLoggedIn(locationDataParams) {
    let ssoUserData       = await ApiService.userdata();
    let individualDetails = sortSsoUserData(ssoUserData);
    let ssoMemberEmail    = individualDetails.email;

    if(Object.keys(ssoUserData).length > 0) {
      if(window.dataLayer.filter(a => a.event === 'general').length < 1) {
        TagManager.dataLayer(Helper.gtmGeneralPageData());
      } 
      if(window.dataLayer.filter(a => a.event === 'userData').length < 1) {
        TagManager.dataLayer(Helper.gtmUserData(ssoUserData.card.currentTiering, ssoUserData.pmid, true));
      } 
    } else {
      if(window.dataLayer.filter(a => a.event === 'userData').length < 1) {
        TagManager.dataLayer(Helper.gtmUserData("", "", false));
      }
      if(window.dataLayer.filter(a => a.event === 'general').length < 1) {
        TagManager.dataLayer(Helper.gtmGeneralPageData());
      } 
    }

    if(ssoMemberEmail) {
      setIsUserLogged(true)
      let isNotApMember = checkMemberIfAp({"email": ssoMemberEmail}, true, locationDataParams.emailCheck);
      // let isNotApMember = true;
      if(isNotApMember) {
        //populate personal details with SSO user data
        personalDetailsSubmitOverride({
          "first_name"             : individualDetails.first_name || "",
          "last_name"              : individualDetails.last_name || "",
          "phone_number"           : individualDetails.phone_number,
          "title"                  : individualDetails.title,
          "address_line_1"         : individualDetails.address_line_1,
          "city"                   : individualDetails.city,
          "state"                  : individualDetails.state,
          "postcode"               : individualDetails.postcode,
          "country"                : individualDetails.country,
          "billing_address_line_1" : individualDetails.billing_address_line_1,
          "billing_city"           : individualDetails.billing_city,
          "billing_country"        : individualDetails.billing_country,
          "billing_state"          : individualDetails.billing_state,
          "billing_postcode"       : individualDetails.billing_postcode || "",
          "type_of_member"         : "primary_owner",
          "email"                  : ssoMemberEmail,
          "pmid"                   : individualDetails.pmid || ""
        });
        setPrimaryPmid(individualDetails.pmid);
      }
    } else {
      setIsUserLogged(false)
    }

    return false;
  }

  function salutationOverride(salutation) {
    switch(salutation) {
      case "DOC":
        return "Doctor";
      case "NA":
        return "Mr";
    }

    return salutation;
  }

  function sortSsoUserData(ssoUserData) {
    let obj = {};
    if(ssoUserData){
      obj["email"]                  = ssoUserData.email;
      obj["first_name"]             = ssoUserData.firstName;
      obj["last_name"]              = ssoUserData.lastName;
      obj["title"]                  = salutationOverride(ssoUserData.salutation);
      obj["pmid"]                   = ssoUserData.pmid;
      obj["address_line_1"]         = ssoUserData.address.address1;
      obj["city"]                   = ssoUserData.address.city;
      obj["state"]                  = ssoUserData.address.state;
      obj["postcode"]               = ssoUserData.address.zipCode;
      obj["country"]                = ssoUserData.address.country;
      obj["billing_address_line_1"] = ssoUserData.address.address1;
      obj["billing_city"]           = ssoUserData.address.city;
      obj["billing_country"]        = ssoUserData.address.country;
      obj["billing_state"]          = ssoUserData.address.state;
      obj["phone_number"]           = ssoUserData.phone;
    }
    
    /*let obj = {};

    //get email
    if(ssoUserData && ssoUserData.individualSubscriptions?.individualSubscription?.length > 0 && ssoUserData.individualSubscriptions.individualSubscription[0].communication) {
      obj["email"] = ssoUserData.individualSubscriptions.individualSubscription[0].communication.value;
    }

    //get Individual name
    if(ssoUserData && ssoUserData.individual) {
      let individual = ssoUserData.individual;
      obj["first_name"] = individual.individualName.firstName;
      obj["last_name"] = individual.individualName.lastName;
      obj["title"] = salutationOverride(individual.individualName.civility);
      //extra
      obj["pmid"] = individual.pmid;
    }

    //get phone number
    if(ssoUserData && ssoUserData.contactMediums && ssoUserData.contactMediums.contactMedium.length > 0) {
      for(let i=0;i<ssoUserData.contactMediums.contactMedium.length;i++) {
        for(let contactMedium in ssoUserData.contactMediums.contactMedium[i]) {
          
          switch(contactMedium) {
            //get address
            case "postalAddress":
              obj["address_line_1"]         = ssoUserData.contactMediums.contactMedium[i].postalAddress.address1;
              obj["city"]                   = ssoUserData.contactMediums.contactMedium[i].postalAddress.city;
              obj["state"]                  = "";
              obj["postcode"]               = ssoUserData.contactMediums.contactMedium[i].postalAddress.zipCode;
              obj["country"]                = ssoUserData.contactMediums.contactMedium[i].postalAddress.countryCode;
              obj["billing_address_line_1"] = ssoUserData.contactMediums.contactMedium[i].postalAddress.address1;
              obj["billing_city"]           = ssoUserData.contactMediums.contactMedium[i].postalAddress.city;
              obj["billing_country"]        = ssoUserData.contactMediums.contactMedium[i].postalAddress.countryCode;
              obj["billing_state"]          = "";
              break;
            case "emailContact":
              obj["email"] = ssoUserData.contactMediums.contactMedium[i].emailContact.email;
              break;
            case "telephoneNumber":
              obj["phone_number"] = ssoUserData.contactMediums.contactMedium[i].telephoneNumber.phoneNumber;
              break;
          }
        }
      }
    }*/
    return obj;
  }

  async function checkMemberIfAp(params, redirect, apiKey) {
    let memberStatusResult = await ApiService.memberStatus(params, apiKey)
    .then(res => res.json());


    if(memberStatusResult) {
      switch(memberStatusResult.status_text) {
        case "MEMBER-Current Member" || "MEMBER-In Progress":
          //redirect to renewal
          if(redirect) window.location = baseUrl + "renewals"; 
          break;
        case "MEMBER-Lapsed Member":
          //do not redirect but populate customer details
          return true;
      }
      return false;
    }
  }

  // [Primary] Personal Details Submit
  const personalDetailsSubmitOverride = event => {
    let input_data = event;
    
    const personalDetails = {
      "email": input_data.email,
      "title": input_data.title,
      "first_name": input_data.first_name,
      "last_name": input_data.last_name,
      "phone_number": {
        "leahNum": input_data.phone_number,            
        "inputVal": input_data.phone_number
      }
    }
    sessionStorage.setItem('personal_details', JSON.stringify(personalDetails));
    
    const country = Global.COUNTRY_LIST.filter(x => x.code === input_data.country.toLowerCase())
    const billingCountry = Global.COUNTRY_LIST.filter(x => x.code === input_data.billing_country.toLowerCase())
    let addressDetails;

    if(input_data.address_line_1 == input_data.billing_address_line_1) {      
      setCheckboxAddress(true) // set the checkbox to true if address are equal
      addressDetails = {
        address_line_1: input_data.address_line_1,
        address_line_2: input_data.address_line_2 ? input_data.address_line_2 : '',
        address_line_3: input_data.address_line_3 ? input_data.address_line_3 : '',
        city: input_data.city,
        state: input_data.state,
        postcode: input_data.postcode,
        country: country ? country[0].label : '',
      }
    } else {
      setCheckboxAddress(false) // set the checkbox to false if address aren't the same
      addressDetails = {
        address_line_1: input_data.address_line_1,
        address_line_2: input_data.address_line_2 ? input_data.address_line_2 : '',
        address_line_3: input_data.address_line_3 ? input_data.address_line_3 : '',
        city: input_data.city,
        state: input_data.state,
        postcode: input_data.postcode,
        country: country ? country[0].label : '',
        billing_address_line_1: input_data.billing_address_line_1,
        billing_address_line_2: input_data.billing_address_line_2 ? input_data.billing_address_line_2 : '',
        billing_address_line_3: input_data.billing_address_line_3 ? input_data.billing_address_line_3 : '',
        billing_city :  input_data.billing_city,
        billing_country : billingCountry ? billingCountry[0].label : '',
        billing_postcode : input_data.billing_postcode,
        billing_state : input_data.billing_state,
      }
    }    
    sessionStorage.setItem('address_details', JSON.stringify(addressDetails));
    getLocalStorageDatas();
  };

  function removeProduct(product) {
    
    setStep(1);
    if(product.type_of_member === 'supp') {
      window.sessionStorage.removeItem('secondary_selected_membership');
      window.sessionStorage.removeItem('secondary_personal_details');
      window.sessionStorage.removeItem('secondary_address_details');
    }
    let updatedProducts = secondaryProducts.map((item) => {
      if(item.item_group_id === product.selected_product[0].item_group_id) {
        return {
            ...item, 
            isSelected: false
        }
      } else {
        return {
          ...item, 
        }
      }
    });
    setSecondaryMemberProducts(updatedProducts);
  }

  function getPath(navigationStep) {
    var path = window.location.search + Helper.navigate(navigationStep) + commissionJunction;
    return path;
  }

  // function isQbrEligible() {
  //   let selectedProduct = products.filter(x => x.isSelected === true);
  //   console.log('selectedProduct', selectedProduct[0].isQbr === undefined)

  // }


  // Footer Button && Progressbar function
  function goNextStep() {
    // Check if region is QBR enabled and skip step if not.
    // QBR Step [3]
    let navigationStep = step;
    if(step === 2 && !isQbr && !Helper.hotelDetected()) {
      setStep(4);
      navigationStep = 4;
    } else if(step === 1 && couponData.length > 0) {
      setStep(4);
      navigationStep = 4;
    } else if(step === 1 && Helper.hotelDetected()) {
      setStep(4);
      navigationStep = 4;
    } else if(step === 1 && isQbr) {
      setStep(3);
      navigationStep = 3;
    } else if(step === 5 && !isSecondaryMember) {
      setStep(8);
      navigationStep = 8;
    } else {
      setStep(step + 1);
      navigationStep = step + 1;
    }
    navigate(getPath(navigationStep));
  }

  // Footer Button && Progressbar function
  function goPreviousStep() {
    // Check if region is QBR enabled and skip step if not. 
    // QBR Step [3]
    let navigationStep = step;
    if(step === 4 && !isQbr && !Helper.hotelDetected()) {
      setStep(1);
      navigationStep = 1;
    } else if(step === 4 && couponData.length > 0) {
      setStep(1);
      navigationStep = 1;
    } else if(step === 4 && Helper.hotelDetected()) {
      setStep(1);
      navigationStep = 1;
    } else if(step === 3 && isQbr) {
      setStep(1);
      navigationStep = 1;
    } else if(step === 8 && !isSecondaryMember) {
      setStep(5);
      navigationStep = 5;
    } else {
      setStep(step - 1);
      navigationStep = step - 1;
    }
    const path = window.location.search + Helper.navigate(navigationStep);
    navigate(path);
  }

  function productsForGtm() {
    
    let products = [];
    if(localStorageDatas.members[0].selected_product[0] !== undefined) {
      for(let i=0;i<localStorageDatas.members.length;i++) {
        let item_selected = localStorageDatas.members[i].selected_product;
        var getCoupon = Helper.checkCoupon(item_selected[0], couponData);
        let member = localStorageDatas.members[i];
        products.push({
          "item_id": member.selected_product[0].item_group_id,
          "item_name": member.selected_product[0].item_group_description,
          "price": parseFloat(member.selected_product[0].purchase_price) + parseFloat((member.selected_product[0].tax_amt || member.selected_product[0].tax_amount)),
          "coupon": getCoupon.exists ? getCoupon.coupon_code_id : "No coupon", 
          "affiliation": "Accor Plus",
          "currency": member.selected_product[0].currency_text,
          "discount": getCoupon.exists ? getCoupon.total : 0.00,
          "index": i,
          "item_brand": "Accor Plus",
          "item_category": member.selected_product[0].item_group_name,
          "location_id": locationDatas.subsidiary,
          "quantity": 1        
        });
      }
      return products;
    }
  }


  //Payment Process Transaction ID
  const processPayment = async (transactionId, subscriptionTransaction, paymentType) => {
    if(window.dataLayer.filter(a => a.event === 'begin_checkout').length < 1) {
      TagManager.dataLayer(Helper.gtmBeginCheckout(locationDatas.currency, window.location.pathname, productsForGtm()));
      commissionJunction = commissionJunctionRules(locationDatas, paymentType);
    }  
    const payment_data = {
      ...localStorageDatas,
      "transactionId": transactionId,
      "subscriptionTransaction": subscriptionTransaction,
      "paymentType": paymentType
    }
    setLocalStorageDatas(payment_data);
    goNextStep();
    // or we can add everything here.    
  }


  // [Step] - Review
  async function confirmOrder() {    
    setReviewLoading(true);
    let payloadObj = {};
    let payload    = [];
    let child_of   = '';

    for(let[index, member]  of localStorageDatas.members.entries()) {
      setReviewLoading(true);
      let businessCategoryObj;
      if(Object.keys(member.selected_product).length !== 0) {
        businessCategoryObj = localStorageDatas.business_categories[member.selected_product[0].business_category_id];
      }
      payloadObj = {
        "subsidiary"         : businessCategoryObj.subsidiary,
        "location"           : businessCategoryObj.location_id,
        "department"         : businessCategoryObj.department_id,
        "salutation"         : member.title,
        "memberid"           : member.memberid ? member.memberid : "",
        "firstname"          : member.first_name,
        "lastname"           : member.last_name,
        "email"              : member.email,
        "phone1_type"        : null,
        "phone1"             : (member.phone_number.countryCodeValLeading0 ? member.phone_number.countryCodeValLeading0.toString() : ""),
        "leah_phone"         : (member.phone_number.countryCodeValLeading0 ? member.phone_number.countryCodeValLeading0.toString() : ""),
        "prefix"             : member.phone_number.dialCode,
        "home_addr1"         : member.address_line_1,
        "home_addr2"         : member.address_line_2,
        "home_addr3"         : member.address_line_3,
        "home_zip"           : member.postcode,
        "home_city"          : member.city,
        "home_country"       : member.country,
        "home_state"         : member.state,
        "ship_addr1"         : member.billing_address_line_1,
        "ship_addr2"         : member.billing_address_line_2,
        "ship_addr3"         : member.billing_address_line_3,
        "ship_zip"           : member.billing_postcode,
        "ship_city"          : member.billing_city,
        "ship_country"       : member.billing_country,
        "ship_state"         : member.billing_state,
        "referrer_name"      : "",
        "hotel_last_stay"    : "",
        "source"             : Helper.hotelDetected() ? "Hotel" : "Website",
        "partner_ref_number" : partnerRefNumber,
        "preferred_language" : member.preferred_language ? member.preferred_language : "en"
      };
      if(member.type_of_member == "supp") {
        payloadObj["child_of"] = child_of;
      }

      payload.push(payloadObj);


      let params = {
        "abn":partnerRefNumber,
        "accountManagerDetails":{
            "title":member.title,
            "firstName": member.first_name,
            "lastName": member.last_name,
            "emailAddress": member.email,
            "mobile":{
                "countryCode":member.phone_number.dialCode,
                "number":member.phone_number.localNumber
            }
        }
      }

      let result_member_id;

      if(member.type_of_member == "primary_owner"){
        // if(Helper.isQbr() && isQBRnewMember && partnerRefNumber){
        // setReviewLoading(true);
        if((Helper.isQbr(locationDatas) || member.selected_product[0]?.isQbr) && partnerRefNumber){
          qbrJoinApi(params, index, payloadObj, payload, member);
          // const result_member_id = await memberApi(index, payloadObj, payload, member);
          
        } else {
          result_member_id = await memberApi(index, payloadObj, payload, member);
          setReviewLoading(false);
        }
        child_of = result_member_id;
      }
      //get the primary memberId from the api to add on to the supp
      
      if(member.type_of_member == "supp") {
        result_member_id = await memberApi(index, payloadObj, payload, member);
        setReviewLoading(false);
      }
      
      
      //localStorageDatas.members[index].memberid = result_member_id;
      //getLocalStorageDatas();
    }
    // setReviewLoading(false);
    if(!partnerRefNumber) {
      goNextStep();
    }
  }

  async function memberApi(payloadIndex, memberPayload, payload, member) {    
    let memberid = '';
    if(localStorageDatas.members[payloadIndex]["memberid"]) {
      if(memberPayload["subsidiary"]) {
        memberPayload["subsidiary"] = null;
      }
      await ApiService.memberUpdate(memberPayload)
        .then(res => res.json())
        .then((result) => {
          if(member.type_of_member == "primary_owner"){
            memberid = result.memberid;

            if(result.errorMessage) {
              setMemberCreationError(`ErrCode (1016) : Not updated correctly. Check your details and try again.`);
              setReviewLoading(false);
              throw("ERROR")
            }

            //lookup subsidiary
            let subResult = subsidiaryLookup(result.subsidiary);
            if(!subResult.found) {
              //not matching subsidiary so send error message
              setMemberCreationError(`Our records show that you are registered in ${subResult.country}. Would you like to switch to <a href="/${subResult.code}/registration/?redirect=F" style="display: inline;text-decoration: underline;">${subResult.country}</a>? Otherwise, please contact <a target="_blank" href='https://accorplushelp.zendesk.com/hc/en-au' style="display: inline;text-decoration: underline;"> Member Services</a> to complete your transaction.`);
              setReviewLoading(false);
              throw("ERROR");
              //return;
            }
          }
          if(result.errorMessage) {
            console.error("ERROR", result.errorMessage);
            setMemberCreationError(result.errorMessage);
          } 
        },(error) => {
          console.error('error', error);
        });
    } else {
      await ApiService.memberCreate(memberPayload)
        .then(res => res.json())
        .then((result) => {

          
          if(member.type_of_member === 'primary_owner') {
            setMemberId(result.memberid)
          } else if (member.type_of_member === 'supp') {
            setSecondaryMemberId(result.memberid)
          }
          localStorageDatas.members[payloadIndex]["memberid"] = result.memberid;


          if(member.type_of_member == "primary_owner"){
            memberid = result.memberid;

            //lookup subsidiary
            let subResult = subsidiaryLookup(result.subsidiary);
            if(result.errorMessage) {
              setMemberCreationError(`ErrCode (1015) : Not registered correctly. Check your details and try again.`);
              setReviewLoading(false);
              throw("ERROR")
            }

            if(!subResult.found) {
              //not matching subsidiary so send error message
              setMemberCreationError(`Our records show that you are registered in ${subResult.country}. Would you like to switch to <a href="/${subResult.code}/registration/?redirect=F" style="display: inline;text-decoration: underline;">${subResult.country}</a>? Otherwise, please contact <a target="_blank" href='https://accorplushelp.zendesk.com/hc/en-au' style="display: inline;text-decoration: underline;"> Member Services</a> to complete your transaction.`);
              setReviewLoading(false);
              throw("ERROR")
              //return;
            }
          }
          if(result.errorMessage) {
            console.error("ERROR", result.errorMessage);
            setMemberCreationError(result.errorMessage);
          }
        },(error) => {
          console.error('error', error);
        });
    }
    return memberid ;
  }

  async function qbrValidation(result, index, payloadObj, payload, member) {
    let child_of   = '';
    if(typeof result === 'object'){
      if(result.errorMessage) {
        let errMsg = result.fieldErrorMessages[0]?.errorMessage || result.errorMessage;
        if(result.errorCode === "ABN_ALREADY_REGISTERED" || result.errorCode === "EMAIL_ALREADY_REGISTERED" || result.errorCode === "ENTITY_ALREADY_EXISTS") {
          setMemberCreationError('');
          let result_member_id = await memberApi(index, payloadObj, payload, member);
          child_of = result_member_id;
          setReviewLoading(false);
          goNextStep();          
        } else {
          // (result.errorMessage === "Invalid request payload - invalid request body") 
          setMemberCreationError(errMsg);
          setReviewLoading(false);
          throw("ERROR");
        }         
      } else if(result.status === 'ACTIVE' || result.status === 'active') {
        setMemberCreationError('');
        let result_member_id = await memberApi(index, payloadObj, payload, member);
        child_of = result_member_id;
        setReviewLoading(false);
        goNextStep();        
      } else {        
        setMemberCreationError(error.fieldErrorMessages[0].errorMessage);
      }
    } 
    else {
      setMemberCreationError(QBR_JOIN_ERROR_MESSAGE);
      setReviewLoading(false);
      throw("ERROR");
    }
  }

  async function qbrJoinApi(params, index, payloadObj, payload, member){
   await ApiService.qbrJoin(params)
      .then(res => res.json())
      .then((result) => {      
        qbrValidation(result, index, payloadObj, payload, member)
      },(error) => {
        if(error && error.responseJSON.fieldErrorMessages && error.responseJSON.fieldErrorMessages[0].errorMessage){
          setMemberCreationError(error.fieldErrorMessages[0].errorMessage);
        }else{
          setMemberCreationError(QBR_JOIN_ERROR_MESSAGE);
        }
        setReviewLoading(false);
        throw("ERROR");
      });      
    return;
  }

  function subsidiaryLookup(subsidiary) {

    if(locationDatas.subsidiary == subsidiary) {
      let country = Helper.lookupSubsidiaryCountry(subsidiary);
      return {
        "subsidiary": subsidiary,
        "found": true,
        "country": country.label,
        "code": country.code
      };
    }
    let country = Helper.lookupSubsidiaryCountry(subsidiary);
    return {
      "subsidiary": subsidiary,
      "found": false,
      "country": country.label,
      "code": country.code
    };
  }

  // Header Text title
  function setHeaderStepText(steps, language) {
    var currentStep = Helper.getSteps(steps);
    const title     = Helper.getStepsTitle(currentStep, language);
    setHeaderText(title);
  }

  function getGtmProduct(product, index) {
    let products = [];
      if(product !== null) {

        var member = product
        let item_selected = member[0]; // check
        var getCoupon = Helper.checkCoupon(item_selected, couponData);

        products.push({
          "item_id": item_selected.item_group_id,
          "item_name": item_selected.item_group_description,
          "price": parseFloat(item_selected.purchase_price) + parseFloat((item_selected.tax_amt || item_selected.tax_amount)),
          "coupon": getCoupon.exists ? getCoupon.coupon_code_id : "No coupon", 
          "affiliation": "Affiliation name/Accor plus",
          "currency": item_selected.currency_text,
          "discount": getCoupon.exists ? getCoupon.total : 0.00,
          "index": index,
          "item_brand": "Accor Plus",
          "item_category": item_selected.item_group_name,
          "location_id": locationDatas.subsidiary,
          "quantity": 1  
        });
      }
      return products;
    
  }
 
  // Membersip Localstorage store
  function storeMembershipData(identifier) {
    if (identifier === 1) {
      let selectedProduct = products.filter(x => x.isSelected === true);
      let isProductSelectedQBR = products.filter(x => x.isQbr === true);

      var prevProd = JSON.parse(sessionStorage.getItem('selected_membership'));
      if(prevProd !== null) {
        if(selectedProduct[0]?.item_group_id !== prevProd[0]?.item_group_id) { // both aren't equal, remove the 
          TagManager.dataLayer(Helper.gtmEcommerceCart('remove_from_cart', 'primary', getGtmProduct(prevProd, 0)))
          TagManager.dataLayer(Helper.gtmEcommerceCart('add_to_cart', 'primary', getGtmProduct(selectedProduct, 0)))
        } 
      } else {
        TagManager.dataLayer(Helper.gtmEcommerceCart('add_to_cart','primary', getGtmProduct(selectedProduct, 0)))
      }
      sessionStorage.setItem('selected_membership', JSON.stringify(selectedProduct));
      goNextStep();
    } else if (identifier === 2) {
      let secondarySelectedProduct = secondaryProducts.filter(x => x.isSelected === true);
      var prevProd = JSON.parse(sessionStorage.getItem('secondary_selected_membership'));
      if(secondarySelectedProduct !== null && prevProd === null) {
        TagManager.dataLayer(Helper.gtmEcommerceCart('add_to_cart_two', 'supp', getGtmProduct(secondarySelectedProduct, 1)))
        TagManager.dataLayer(Helper.gtmGeneralCheckoutStep('checkoutstep_two', getPath(step), step))
      } 
      sessionStorage.setItem('secondary_selected_membership', JSON.stringify(secondarySelectedProduct));
      goNextStep();
    }
  }
  
  // Button Product - Membership Selection
  function selectMembership(e) {
    let updatedProducts = products.map((item) => {
      if(item.item_group_id === e.item_group_id && item.item_group_description === e.item_group_description) {
        return { 
          ...item, 
          isSelected: true 
        }
      } else {
        return { ...item, isSelected: false }
      }
    });
    // add a cart
    setProducts(updatedProducts);
    // Check if product is qbr eligible
    if((e.isQbr !== undefined && e.isQbr === true) || Helper.isQbr(locationDatas)) {
      setIsQbr(true)
    } else {
      setIsQbr(false)
    }
  }

  // Button Product - Membership Selection
  function selectSecondaryMembership(e) {
    let updatedProducts = secondaryProducts.map((item) => {
      if(item.isSelected === true) {
        //remove selected
        return {
          ...item, 
          isSelected: !item.isSelected
        }
      }
      if(item.item_group_id === e.item_group_id) {
        return {
          ...item, 
          isSelected: true
        }
      } 
      else {
          return {
            ...item, 
            isSelected: false
          }
      }
    });
    setIsSecondaryMember(true);
    setSecondaryMemberProducts(updatedProducts);
  }

  function declinedSecondaryMembership() {
    setIsSecondaryMember(false);
    var prevProd = JSON.parse(sessionStorage.getItem('secondary_selected_membership'));
      if(prevProd !== null) {
        TagManager.dataLayer(Helper.gtmEcommerceCart('remove_from_cart_two', 'supp', getGtmProduct(prevProd, 1)))
        window.sessionStorage.removeItem('secondary_selected_membership')
      }
    goNextStep();
  }

  const fetchLanguages = async () => {
    const region = locationParam.country.toLowerCase() || 'au';
    let regionLanguage;
    await ApiService.getLanguages()
      .then(res => res.json())
      .then(
      (result) => {        
        setAllLanguages(result);
        setLocalLanguage(result)
        var currentStep = Helper.getSteps(step);
        const title     = Helper.getStepsTitle(currentStep, regionLanguage);
        setLanguages(regionLanguage);
        setHeaderText(title);     
      },
      (error) => {
        //console.log("EXEC ERROR", error);
        setAllLanguages(languagesData);
        setLocalLanguage(languagesData)
        var currentStep = Helper.getSteps(step);
        const title     = Helper.getStepsTitle(currentStep, regionLanguage);
        setLanguages(regionLanguage);
        setHeaderText(title);
        setInputLanguages(setInputFields, inputFields, languages)
      }
      );

    function setLocalLanguage(data) {
      if(data) {
        var found = false;
        for (const [key, value] of Object.entries(data)) {                       
          if(key.indexOf(region) > -1) {
            if(window.location.href.indexOf("localhost") != -1) {              
              found          = true;
                regionLanguage = data['au'];
              if(key == "th") {
                found          = true;
                regionLanguage = value;
              } else if(key == "vn") {
                found          = true;
                regionLanguage = value;
              } else if(key == "id") {
                found          = true;
                regionLanguage = value;
              } else {
                found          = true;
                regionLanguage = data['en_master'];
              }
            } else {              
              if(key == "th" && window.location.pathname == "/th/th/registration/") {
                found          = true;
                regionLanguage = value;
              } else if(key == "vn" && window.location.pathname == "/vn/vi/registration/") {
                found          = true;
                regionLanguage = value;
              } else if(key == "id" && window.location.pathname == "/id/id/registration/") {
                found          = true;
                regionLanguage = value;
              } else {
                found          = true;
                regionLanguage = data['en_master'];
              }
            }
          }
        }
        if(!found) {
          regionLanguage = data['en_master'];
        }
      }
    }
  }

  
 

  // [Primary] Main Address
  const addressInputDetails = [
    {
      name        : 'address_line_1',
      type        : 'text',
      value       : '',
      maxLength   : 32,
      placeholder : 'Address Line 1*',
      textHolder  : 'primaryBillingAddressLine1',
      icon        : Home,
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    },
    {
      name        : 'address_line_2',
      type        : 'text',
      value       : '',
      maxLength   : 32,
      placeholder : 'Address Line 2',
      textHolder  : 'primaryBillingAddressLine2',
      icon        : Home,
      required    : false,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    },
    {
      name        : 'address_line_3',
      type        : 'text',
      value       : '',
      maxLength   : 32,
      placeholder : 'Address Line 3',
      textHolder  : 'primaryBillingAddressLine3',
      icon        : Home,
      required    : false,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    },
    {
      name        : 'city',
      type        : 'text',
      value       : '',
      placeholder : 'City*',
      textHolder  : 'primaryBillingAddressCity',
      icon        : City,
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'state',
      type        : 'text',
      value       : '',
      placeholder : 'State',
      textHolder  : 'primaryBillingAddressState',
      required    : false,
      icon        : State,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'postcode',
      type        : 'text',
      value       : '',
      placeholder : 'Postcode',
      textHolder  : 'secondaryBillingAddressPostcode',
      icon        : Postcode,
      required    : false,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'country',
      type        : 'select',
      options     : countryList,
      value       : selectedCountry,
      placeholder : 'Country*',
      textHolder  : 'secondaryBillingAddressCountry',
      icon        : Country,
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }
  ]

  // [Secondary] Main Address
  const secondaryAddressInputDetails = [
    {
      name        : 'address_line_1',
      type        : 'text',
      maxLength   : 32,
      value       : '',
      placeholder : 'Address Line 1*',
      textHolder  : 'secondaryBillingAddressLine1',
      icon        : Home,
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'address_line_2',
      type        : 'text',
      maxLength   : 32,
      value       : '',
      placeholder : 'Address Line 2',
      textHolder  : 'secondaryBillingAddressLine2',
      icon        : Home,
      required    : false,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'address_line_3',
      type        : 'text',
      value       : '',
      maxLength   : 32,
      placeholder : 'Address Line 3',
      textHolder  : 'secondaryBillingAddressLine3',
      icon        : Home,
      required    : false,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    },
    {
      name        : 'city',
      type        : 'text',
      value       : '',
      placeholder : 'City*',
      textHolder  : 'secondaryBillingAddressCity',
      icon        : City,
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'state',
      type        : 'text',
      value       : '',
      placeholder : 'State',
      textHolder  : 'secondaryBillingAddressState',
      required    : false,
      icon        : State,
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'postcode',
      type        : 'text',
      value       : '',
      placeholder : 'Postcode',
      textHolder  : 'secondaryBillingAddressPostcode',
      icon        : Postcode,
      required    : false,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'country',
      type        : 'select',
      options     : countryList,
      value       : selectedCountry,
      placeholder : 'Country*',
      textHolder  : 'secondaryBillingAddressCountry',
      icon        : Country,
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }
  ]
  
  // [Primary] Billing / Shipping Address
  const billingAddress = [
    {
      name        : 'billing_address_line_1',
      type        : 'text',
      maxLength   : 32,
      placeholder : 'Shipping Address Line 1*',
      textHolder  : 'primaryShippingAddressLine1',
      icon        : Home,
      value       : '',
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, {
      name        : 'billing_address_line_2',
      type        : 'text',
      maxLength   : 32,
      placeholder : 'Shipping Address Line 2',
      textHolder  : 'primaryShippingAddressLine2',
      icon        : Home,
      value       : '',
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    },
    {
      name        : 'billing_address_line_3',
      type        : 'text',
      maxLength   : 32,
      placeholder : 'Shipping Address Line 3',
      textHolder  : 'primaryShippingAddressLine3',
      icon        : Home,
      value       : '',
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
      }, {
      name        : 'billing_city',
      type        : 'text',
      placeholder : 'City*',
      textHolder  : 'primaryShippingAddressCity',
      icon        : City,
      value       : '',
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, {
      name        : 'billing_state',
      type        : 'text',
      placeholder : 'State',
      textHolder  : 'primaryShippingAddressState',
      required    : false,
      icon        : State,
      value       : '',
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, {
      name        : 'billing_postcode',
      type        : 'number',
      placeholder : 'Postcode*',
      textHolder  : 'primaryShippingAddressPostcode',
      icon        : Postcode,
      value       : '',
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'billing_country',
      type        : 'select',
      options     : countryList,
      placeholder : 'Country*',
      textHolder  : 'primaryShippingAddressCountry',
      icon        : Country,
      value       : selectedCountry,
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }
  ]

  // [Secondary] Billing / Shipping Address
  const secondaryBillingAddress = [
    {
      name        : 'billing_address_line_1',
      type        : 'text',
      maxLength   : 32,
      placeholder : 'Shipping Address Line 1*',
      textHolder  : 'secondaryShippingAddressLine1',
      icon        : Home,
      value       : '',
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'billing_address_line_2',
      type        : 'text',
      maxLength   : 32,
      placeholder : 'Shipping Address Line 2',
      textHolder  : 'secondaryShippingAddressLine2',
      icon        : Home,
      value       : '',
      required    : false,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'billing_address_line_3',
      type        : 'text',
      maxLength   : 32,
      placeholder : 'Shipping Address Line 3',
      textHolder  : 'secondaryShippingAddressLine3',
      icon        : Home,
      value       : '',
      required    : false,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'billing_city',
      type        : 'text',
      placeholder : 'City*',
      textHolder  : 'secondaryShippingAddressCity',
      icon        : City,
      value       : '',
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'billing_state',
      type        : 'text',
      placeholder : 'State',
      textHolder  : 'secondaryShippingAddressState',
      required    : false,
      icon        : State,
      value       : '',
      required    : true,
      message     : '',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'billing_postcode',
      type        : 'number',
      placeholder : 'Postcode*',
      textHolder  : 'secondaryShippingAddressPostcode',
      icon        : Postcode,
      value       : '',
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }, 
    {
      name        : 'billing_country',
      type        : 'select',
      options     : countryList,
      placeholder : 'Country*',
      textHolder  : 'secondaryShippingAddressCountry',
      icon        : Country,
      value       : selectedCountry,
      required    : true,
      message     :'',
      isError     : false,
      valid       : false,
      checking    : false
    }
  ]

  // [Primary] 

  //Main Address
  const [primaryAddressInputFields, setPrimaryAddressInputFields] = useState(addressInputDetails);
  var primaryCountryOfSelection = primaryAddressInputFields.filter(a => a.name === 'country')

  //Billing / Shipping Address
  const [primaryBillingAddressInputFields, setPrimaryBillingAddressInputFields] = useState(billingAddress);
  var primaryBillingCountryOfSelection = primaryBillingAddressInputFields.filter(a => a.name === 'billing_country')

  // [Secondary] 
  //Main Address
  const [primarySecondaryAddressInputFields, setSecondaryPrimaryAddressInputFields] = useState(secondaryAddressInputDetails);
  var secondaryCountryOfSelection = primarySecondaryAddressInputFields.filter(a => a.name === 'country')
  
  //Billing / Shipping Address
  const [primarySecondaryBillingAddressInputFields, setSecondaryPrimaryBilliingAddressInputFields] = useState(secondaryBillingAddress);
  var secondaryBillingCountryOfSelection = primarySecondaryBillingAddressInputFields.filter(a => a.name === 'billing_country')
  
  const [isPrimaryPostalRequired, setIsPrimaryPostalRequired] = useState(true)
  const [isPrimaryBillingPostalRequired, setIsPrimaryBillingPostalRequired] = useState(true)
  const [isPrimaryStateRequired, setIsPrimaryStateRequired] = useState(true)

  const [isSecondaryPostalRequired, setIsSecondaryPostalRequired] = useState(true)
  const [isSecondaryBillingPostalRequired, setIsSecondaryBillingPostalRequired] = useState(true)
  const [isSecondaryStateRequired, setIsSecondaryStateRequired] = useState(true)


  //Primary Main Address
  useEffect(() => {
    if(primaryCountryOfSelection) {
      const primaryCountry = Global.CODED_COUNTRY_LIST.filter(a => a.name === primaryCountryOfSelection[0].value)
      let countryCode = primaryCountry[0] === undefined ? 'us' : primaryCountry[0].code
      handleOnUpdateAddress('state' ,{'country': countryCode}, primaryCountry, primaryAddressInputFields, setPrimaryAddressInputFields, setIsPrimaryPostalRequired, setIsPrimaryStateRequired)
    }
  }, [primaryCountryOfSelection[0].value]);


  //Primary Billing Address
  useEffect(() => {
    if(primaryBillingCountryOfSelection) {
      const primaryBillingCountry = Global.CODED_COUNTRY_LIST.filter(a => a.name === primaryBillingCountryOfSelection[0].value)
      let countryBillingCode = primaryBillingCountry[0] === undefined ? 'us' : primaryBillingCountry[0].code
      handleOnUpdateAddress('billing_state', {'country': countryBillingCode}, primaryBillingCountry, primaryBillingAddressInputFields, setPrimaryBillingAddressInputFields, setIsPrimaryBillingPostalRequired, setIsPrimaryStateRequired)
    }
  }, [primaryBillingCountryOfSelection[0].value]);

  //Secondary Main Address
  useEffect(() => {
    if(secondaryCountryOfSelection) {
      const secondaryCountry = Global.CODED_COUNTRY_LIST.filter(a => a.name === secondaryCountryOfSelection[0].value)
      let countryCode = secondaryCountry[0] === undefined ? 'us' : secondaryCountry[0].code
      handleOnUpdateAddress('state' ,{'country': countryCode}, secondaryCountry, primarySecondaryAddressInputFields, setSecondaryPrimaryAddressInputFields, setIsSecondaryPostalRequired, setIsSecondaryStateRequired)
      // handleOnUpdateAddress({'country': countryCode}, secondaryCountry, primarySecondaryAddressInputFields, setSecondaryPrimaryAddressInputFields, primarySecondaryBillingAddressInputFields, setSecondaryPrimaryBilliingAddressInputFields, setIsSecondaryPostalRequired, setIsSecondaryStateRequired)
    }
  }, [secondaryCountryOfSelection[0].value]);

  //Secondary Billing Address
  useEffect(() => {
    if(secondaryBillingCountryOfSelection) {
      const secondaryBillingCountry = Global.CODED_COUNTRY_LIST.filter(a => a.name === secondaryBillingCountryOfSelection[0].value)
      let countryCode = secondaryBillingCountry[0] === undefined ? 'us' : secondaryBillingCountry[0].code
      handleOnUpdateAddress('billing_state', {'country': countryCode}, secondaryBillingCountry, primarySecondaryBillingAddressInputFields, setSecondaryPrimaryBilliingAddressInputFields, setIsSecondaryPostalRequired, setIsSecondaryStateRequired)
      // handleOnUpdateAddress({'country': countryCode}, secondaryCountry, primarySecondaryAddressInputFields, setSecondaryPrimaryAddressInputFields, primarySecondaryBillingAddressInputFields, setSecondaryPrimaryBilliingAddressInputFields, setIsSecondaryPostalRequired, setIsSecondaryStateRequired)
    }
  }, [secondaryBillingCountryOfSelection[0].value]);

  const handleOnUpdateAddress = async (paramsName, locParams, countryParams, addressFields, setAddressFields, setIsPostal, setIsStateRequired) => {
    setIsPostal(hasPostalCode(countryParams[0].iso)) // returns true or false post code
    let isPostalCountryRequired = hasPostalCode(countryParams[0].iso);


    await ApiService.getLocationData(locParams)
      .then(res => res.json())
      .then(
      (result) => {
        const isStateReq = result === null ? false : result.stateRequired === undefined ? false : result.stateRequired === true ? true : false;
        if(result && result.stateRequired && result.states){
          let state = result.states.map((item)=>{
            return {value:item , text:item }
          })
          let storedAddressData = addressFields.map((item) => {
            if(item.name === paramsName) {
              return {
                ...item,
                type    : 'select',
                options : state,
                placeholder: languages.primaryShippingAddressState ? languages.primaryShippingAddressState : 'State*',
                required: true,
                isError: false,
                message: ''
              }
            } 
            if(item.name === 'postcode') {
              return {
                ...item,
                required : isPostalCountryRequired,
                placeholder: languages.primaryShippingAddressPostcode ? languages.primaryShippingAddressPostcode : 'Postcode' + isPostalCountryRequired === true ? '*' : '',
                isError: false,
                message: ''
              }
            }
            else {
              return {
                ...item
              }
            }
          })
          // let storedBillingAddressData = shippingAddressFields.map((item) => {
          //   if(item.name === 'billing_state') {
          //     return {
          //       ...item,
          //       type    : 'select',
          //       options : state,
          //       placeholder: 'State*',
          //       required: true,
          //       isError: false,
          //       message: ''
          //     }
          //   } 
          //   if(item.name === 'postcode') {
          //     return {
          //       ...item,
          //       required : isPostalCountryRequired,
          //       placeholder: isPostalCountryRequired === true ? 'Postcode*' : 'Postcode',
          //       isError: false,
          //       message: ''
          //     }
          //   }
          //   else {
          //     return {
          //       ...item
          //     }
          //   }
          // })
          setAddressFields(storedAddressData);
          // setAddressFields(storedBillingAddressData);
          
        } else {
          let storedAddressData = addressFields.map((item) => {
            if(item.name === paramsName) {
              return {
                ...item,
                type    : 'text',
                placeholder: isStateReq === true ? languages.primaryShippingAddressState ? languages.primaryShippingAddressState : 'State*' : languages.primaryShippingAddressState ? languages.primaryShippingAddressState :'State',
                required: isStateReq,
                isError: false,
                message: ''
              }
            } 
            if(item.name === 'postcode') {
              return {
                ...item,
                required : isPostalCountryRequired,
                placeholder: isPostalCountryRequired === true ? languages.primaryShippingAddressPostcode ? languages.primaryShippingAddressPostcode :'Postcode*' : languages.primaryShippingAddressPostcode ? languages.primaryShippingAddressPostcode : 'Postcode',
                isError: false,
                message: ''
              }
            }
            else {
              return {
                ...item,                
              }
            }
          })
          // let storedBillingAddressData = shippingAddressFields.map((item) => {
          //   if(item.name === 'billing_state') {
          //     return {
          //       ...item,
          //       type    : 'text',
          //       placeholder: isStateReq === true ? 'State*' : 'State',
          //       required: isStateReq,
          //       isError: false,
          //       message: ''
          //     }
          //   } 
          //   if(item.name === 'billing_postcode') {
          //     return {
          //       ...item,
          //       required : isPostalCountryRequired,
          //       placeholder: isPostalCountryRequired === true ? 'Postcode*' : 'Postcode',
          //       isError: false,
          //       message: ''
          //     }
          //   }
          //   else {
          //     return {
          //       ...item
          //     }
          //   }
          // })
          setAddressFields(storedAddressData);
          // setShippingAddress(storedBillingAddressData);
        }
      },
      (error) => {
        console.error(error)
        // setError(error);
      }
      );   
  }

  const fetchLocationData = async (locParams) => {
    setIsPrimaryPostalRequired(hasPostalCode(primaryCountryOfSelection[0].value))
    setIsSecondaryPostalRequired(hasPostalCode(secondaryCountryOfSelection[0].value))

    await ApiService.getLocationData(locParams)
      .then(res => res.json())
      .then(
      (result) => { 
        setLocationData(result);
        isSSOLoggedIn(result)
        sessionStorage.setItem('location_data', JSON.stringify(result));
        if(result && result.stateRequired && result.states){
          let state = result.states.map((item)=>{
            return {value:item , text:item }
          })
          let storedAddressData = primaryAddressInputFields.map((item) => {
            if(item.name === 'state') {
              return {
                ...item,
                type    : 'select',
                options : state,
                placeholder: languages.primaryBillingAddressState ? languages.primaryBillingAddressState + '*' : 'State*',
                required: true
              }
            } 
            if(item.name === 'postcode') {
              return {
                ...item,
                placeholder: languages.primaryBillingAddressPostcode ? languages.primaryBillingAddressPostcode + '*'  : 'Postcode*',
                required : isPrimaryPostalRequired
              }
            }
            else {
              return {
                ...item
              }
            }
          })
          let storedBillingAddressData = primaryBillingAddressInputFields.map((item) => {
            if(item.name === 'billing_state') {
              return {
                ...item,
                type    : 'select',
                options : state,
                placeholder: languages.primaryShippingAddressState ? languages.primaryShippingAddressState + '*' : 'State*',
                required: true
              }
            } 
            if(item.name === 'postcode') {
              return {
                ...item,
                required : isPrimaryPostalRequired,
                placeholder: languages.primaryShippingAddressPostcode ? languages.primaryShippingAddressPostcode + '*'  : 'Postcode*'
              }
            }
            else {
              return {
                ...item
              }
            }
          })
          setPrimaryAddressInputFields(storedAddressData);
          setSecondaryPrimaryAddressInputFields(storedAddressData);

          setPrimaryBillingAddressInputFields(storedBillingAddressData);
          setSecondaryPrimaryBilliingAddressInputFields(storedBillingAddressData);
        }
        // isSSOLoggedIn()
        setIsLoaded(true);
        
      },
      (error) => {
        setError(error);
        setIsLoaded(true);
      }
      );      
  }

// [QBR][Step]
const eligibilityCheckInputFields = [
  {
      name        : 'abn',
      type        : 'number',
      placeholder : languages.qbrAbn ? languages.qbrAbn :'ABN*',
      icon        : User,
      required    : false,
      value       : ''
  }, 
  {
      name        : 'email',
      type        : 'email',
      placeholder : languages.qbrEmail ? languages.qbrEmail : 'Email*',
      icon        : Mail,
      required    : false,
      value       : ''
  },
]
const [QBRinput, setQBRInput]                 = useState(eligibilityCheckInputFields);
const [isQBRnewMember, setIsQBRnewMember]     = useState(false);
const [isQBRError, setisQBRError]             = useState(false);
const [QBRmessage, setQBRMessage]             = useState('');
const [showQBRTerms, setQBRTerms]             = useState(false);
const inputQBREligibilityEl                   = useRef([]);
const [QBRLoading, setQBRLoading]             = useState(false); 
const [partnerRefNumber, setPartnerRefNumber] = useState('');
const [checkBoxTermsQBR, setCheckBoxTermsQBR] = useState(false);
const [checkBoxConsentQBR, setCheckBoxConsentQBR]                   = useState(false);
const [checkBoxContactInfoQBR, setCheckBoxContactInfoQBR]           = useState(false);
const [showCheckBoxTermsTermsError, setShowCheckBoxTermsTermsError] = useState(false);

function handleCheckBoxTermsQBR() {
  setCheckBoxTermsQBR(!checkBoxTermsQBR)
}

function handleCheckBoxConsentQBR(){
  setCheckBoxConsentQBR(!checkBoxConsentQBR)
}

function handleCheckBoxContactInfoQBR(){
  setCheckBoxContactInfoQBR(!checkBoxContactInfoQBR)
}

function inputQBRChange(e) {
  var name = e.target.name
  var value = e.target.value;
  let storedData = QBRinput.map((input) => {
    if(input.name === name) {
      return {
        ...input,
        value: value
      }
    } else {
      return {
        ...input
      }
    }
  })
  setQBRInput(storedData);
}

function qbrValidate() {
  const qbrData = window.sessionStorage.getItem('qbr_details');
  function qbrValidator(params) {
    if(qbrData === null || qbrData === undefined) {
      return null;
    } else {
      let inputQbr = QBRinput.find(x => x.name === `${params}`).value;
      let storageQbr = JSON.parse(qbrData)[`${params}`]
      return inputQbr === storageQbr;
    }
  }  
  if(!(qbrValidator('abn') && qbrValidator('email'))) {
    setCheckBoxTermsQBR(false)
    setQBRTerms(false)
    setQBRMessage('')
    return false;
  } else {
    return true
  }
}

//validate qbr function
const validateQbr = () => {
  qbrValidate()
  
  // e.preventDefault()
  if(showQBRTerms && !checkBoxTermsQBR){
    setShowCheckBoxTermsTermsError(true);
    return;
  } else{
    setShowCheckBoxTermsTermsError(false);
  }
  setQBRLoading(true);
  let payload = {
    abn   : QBRinput[0].value,
    email : QBRinput[1].value
  }
  sessionStorage.setItem('qbr_details', JSON.stringify(payload));


  if(payload.abn && payload.email) {
      ApiService.qbrEligible(payload)
      .then(res => res.json())
      .then(
      (result) => {
          if(result && result == "EMAIL_ALREADY_REGISTERED") {
            setisQBRError(true);
            setQBRTerms(false);
            setIsQBRnewMember(false);
            setQBRMessage(languages.qbrValidateEmailErrorMessage ? languages.qbrValidateEmailErrorMessage : 'It looks like the email address you entered is already registered with Qantas Business Rewards. Please enter a different email address or contact the <a href="https://www.qantas.com/au/en/business-rewards/qbr/contactus" target="_blank">Qantas Business Rewards service desk</a>.');
          }else if(result && result == "INVALID_INPUT_PARAMETER") {
            setisQBRError(true);
            setQBRTerms(false);
            setIsQBRnewMember(false);
            setQBRMessage(languages.qbrValidateAbnErrorMessage ? languages.qbrValidateAbnErrorMessage :'It looks like there is an error with your ABN. Please provide a different ABN or contact the <a href="https://www.qantas.com/au/en/business-rewards/qbr/contactus" target="_blank">Qantas Business Rewards service desk</a> for assistance.');
          } else if(result && result == "ABN_ALREADY_REGISTERED"){
            // setisQBRError(true);
            // setQBRTerms(false);
            setisQBRError(false);
            setQBRTerms(true)
            setQBRMessage(languages.qbrEligibleSuccessMessage ? languages.qbrEligibleSuccessMessage : 'Great news! Your business is already a Qantas Business Rewards member and is eligible to earn Qantas Points with Accor Plus. <br />By proceeding, you will be joining Accor Plus. Please agree to below the Terms and Conditions and click Next to continue.');
            setIsQBRnewMember(false);
          }else{
            setisQBRError(false);
            setQBRMessage(languages.qbrDisclaimerMessage ? languages.qbrDisclaimerMessage : 'By proceeding, you will be joining Accor Plus and Qantas Business Rewards. After completing your registration, your business will receive 10,000 Qantas Points on Accor Plus Business Explorer Membership.<br />Please agree to below the Terms and conditions and click Next to continue completing the registration form.');
            setQBRTerms(true);
            setIsQBRnewMember(true); 
          }
          setQBRLoading(false);
      },
      (error) => {
          if(error){
            setQBRTerms(false);
            setQBRMessage(error);
          }else{
            setQBRMessage(languages.qbrServerErrorMessage ? languages.qbrServerErrorMessage : "Something went wrong. Please try again later or contact Member Services.");
          }
          setQBRTerms(true);
          setQBRLoading(false);
      }
      );
  } else {
    setisQBRError(true);
    setQBRMessage(languages.qbrValidationEmptyFieldMessage ? languages.qbrValidationEmptyFieldMessage : 'The above fields are mandatory and must be filled.');
    setQBRTerms(false);
    setQBRLoading(false);
  }
};

const confirmValidateQBR = () => {
  if(!QBRLoading && checkBoxTermsQBR && checkBoxConsentQBR && checkBoxContactInfoQBR && qbrValidate()){
    if(QBRinput[1].value){
      let storedData = inputFields.map((inputFields) => {
        if(inputFields.name === 'email') {
          return {
            ...inputFields,
            value:QBRinput[1].value
          }
        } else {
          return {
            ...inputFields
          }
        }
      });
      setInputLanguages(setInputFields, storedData, languages)
      setShowCheckBoxTermsTermsError(false);
      setPartnerRefNumber(QBRinput[0].value);
      goNextStep();
    }else{
      setisQBRError(true);
      setQBRMessage(languages.qbrValidateCheckboxErrorMessage ? languages.qbrValidateCheckboxErrorMessage : 'Something went wrong. Please try again.');
    }
  }else{
    setisQBRError(true);
    setTimeout(() => {
      setQBRMessage(languages.qbrValidateCheckboxErrorMessage ? languages.qbrValidateCheckboxErrorMessage : 'Something went wrong. Please try again.');
    }, 1000);
  }
}

  // Get Stored Product data if available 
  const getStoredProductData = async (params, storageVariable, string) => {
    const productData = window.sessionStorage.getItem(storageVariable);

    if(productData !== null) {
      let storedProducts = await params.map((item) => {
        if(item.item_group_id === JSON.parse(productData)[0].item_group_id) {
            return {
                ...item, 
                isSelected: true
            }
        }
        return item
     });
    if(string === 'primary') {
      setProducts(storedProducts);
    } else if (string === 'secondary') {
      setSecondaryMemberProducts(storedProducts)
    }
     setIsProductLocalStored(true)
    }
  }

  // Get Product Data
  const productData = async () => { 
    let bc         = locationDatas.defaultPriceLevel;
    let pricelevel = null;
    let subsidiary = locationDatas.subsidiary;
    const isDBS    = Helper.isDBS(); 
    let couponCheck = false;
    let couponErrorMessage = '';
    var memberAssistanceMail = '<a href = "mailto: members.singapore@accorplus.com" style="text-decoration:underline;">Member Services</a>'
    var currentMember = false;

    let ui_channel = null;

    if(document.cookie) {
      let json;
      json = document.cookie.split('; ').reduce((prev, current) => {
        const [name, ...value] = current.split('=');
        prev[name] = value.join('=');
        return prev;
      }, {});
      if(json.coupon) {
        var couponObj = JSON.parse(json.coupon);
        setCouponData(couponObj);
        if(couponObj.coupon_code_valid && !couponObj.coupon_code_used) {
            subsidiary = couponObj.subsidiary_id;
            bc         = couponObj.business_category_id;
        }
      }
    }

    if(!isProductLocalStored) {
      bc         = (queryParams.get('bc') ? queryParams.get('bc') : bc);
      pricelevel = (queryParams.get('pricelevel') ? queryParams.get('pricelevel') : pricelevel);
      ui_channel = (queryParams.get('ui_channel') ? queryParams.get('ui_channel') : "");

      if(isDBS.status) { //check if URL has coupon and email to confirm it's DBS
        await ApiService.memberStatus({"email": isDBS.email}, locationDatas.emailCheck)
        .then(res => res.json())
        .then(
        (result) => {
          if(isUserLogged && result.status_text === 'MEMBER-Current Member') {
            currentMember = true;            
          } else {
            currentMember = false;
            couponCheck = false;
          }
        },
        (error) => {
          setError(error);
        })    
      }

      if(!currentMember) {
        if(queryParams.get('email') && queryParams.get('coupon')) {
          await ApiService.getCouponData({'code': queryParams.get('coupon')})
          .then(res => res.json())
          .then(
          (result) => {
            if(result === null) {
              couponCheck = true;
              couponErrorMessage = `We can’t seem to proceed… Please refresh the page and try again. If you require further assistance, please contact our ${memberAssistanceMail} team.`;
              return;
            } else {
              var couponObj = JSON.parse(result);            
              if(!couponObj.coupon_code_valid) { // by default it's true check if coupon code is valid or not
                  couponCheck = true;
                  var validCouponUrl = '<a  style="text-decoration:underline;" target=”_blank” href=\"https://dbswebprv-sg-p02.corp.dbs.com/flp-contact/dbs/cards/dbs-vantage-accor-registration/default.page\">here</a>'
                  couponErrorMessage = `We can’t seem to proceed… Our record shows that the email address provided is not valid. Register for DBS Vantage Visa Infinite Card – Accor Plus Explorer membership ${validCouponUrl}.`
                } else if (couponObj.coupon_code_used) { // by default it's false: check if coupon code is already used.
                  couponCheck = true;
                  couponErrorMessage = `We can’t seem to proceed… Please contact our ${memberAssistanceMail} team for further assistance.`
                } else {
                  subsidiary = couponObj.subsidiary_id;
                  bc         = couponObj.business_category_id;
                }     
                setCouponData(result);
                sessionStorage.setItem('coupon_data', JSON.stringify(result));
            }
          },
          (error) => {
            // add a string checker: ErrCode (1004)
            setError(error);
          }
          );
        }  
      } else {
        couponCheck = true;
        couponErrorMessage = `We can’t seem to proceed… Our record shows that you are currently logged in as a member. Please log out and try again. If you require further assistance, please contact our ${memberAssistanceMail} team.` 
      }
      await ApiService.getProducts(bc, subsidiary, null, pricelevel, ui_channel)
        .then(res => res.json())
        .then(
        (result) => {
            if(result.errorMessage){
                setProductError('Error: ' + result.errorMessage);
            }else{
                
                //Filter products depending on the scenario
                if(couponCheck) {
                  setProductError(couponErrorMessage);
                  setIsProductLoaded(true);
                  return;
                }
                
                const businessCategoryId = result.item_groups[0]?.business_category_id;
                const salesTypeId = Object.values(result.business_categories).find(businessCategories => businessCategories.business_category_id === businessCategoryId).sales_type_id;
                localStorage.setItem("salesTypeId", salesTypeId);
                
                setBC(result.business_categories);
                setBusinessCategories(result.business_categories);
                if(ui_channel) {
                  bc = null;
                  pricelevel = null;
                }
                const filteredProducts = Helper.filterProducts(bc, pricelevel, result, locationDatas);
                //console.log("result filteredProducts", filteredProducts);
                const standaloneProducts = result.item_groups.filter(x => x.non_standalone);
                
                setProductError('');
                setError('');
                //setProducts(result.item_groups);
                setProducts(filteredProducts);
                setSecondaryMemberProducts(standaloneProducts);                
                if(result.item_groups.length > 0 && result.item_groups[0].currency_text && locationDatas.currency) {
                  let locationDataCurrency = locationDatas.currency;
                  let productCurrency      = result.item_groups[0].currency_text;
                  if(locationDataCurrency != productCurrency) {
                    setProductError(languages.merchantMatchErrorMessagePurchase ? languages.merchantMatchErrorMessagePurchase : "You cannot purchase in " + locationDatas.currency + ". " + languages.merchantMatchErrorMessageLink ? languages.merchantMatchErrorMessageLink : "Merchant not available. Please <a href='contact' style='display: contents;'>contact Member Services</a> for more information.");
                  }
                }
            }
            setIsProductLoaded(true);
        },
        (error) => {
          setIsProductLoaded(true);
            setProductError(error);
        }
      );
    }
        
  }

  // Load saved Localstorage if exists
  const getLocalStorageDatas = () => {
    const productData = window.sessionStorage.getItem('selected_membership');
    if ( productData !== null ) var storageLocalProductData = JSON.parse(productData);

    const personalData = window.sessionStorage.getItem('personal_details');
    if ( personalData !== null ) {
      var storageLocalPersonalData = JSON.parse(personalData);

      let storedData = inputFields.map((inputFields) => {
        if(inputFields.name) {
          return {
            ...inputFields,
            value: storageLocalPersonalData[inputFields.name]
          }
        }
      })
      // setInputFields(storedData)
      setInputLanguages(setInputFields, storedData, languages)
      // setpersonalDetailsInput(JSON.parse(personalData));
    }
    
    const addressData = window.sessionStorage.getItem('address_details');
    if ( addressData !== null ) {
      var storageLocalAddressData = JSON.parse(addressData);
      // setAddressInput(JSON.parse(addressData))
      if(primaryAddressInputFields !== null) {
        let primaryAddressStorage = primaryAddressInputFields.map((primaryAddressInputFields) => {
          if(primaryAddressInputFields.name) {
            return {
              ...primaryAddressInputFields,
              value: storageLocalAddressData[primaryAddressInputFields.name]
            }
          }  
        })
        setPrimaryAddressInputFields(primaryAddressStorage);
        setFindMyaddessInGoogle(false);
      }

      if(primaryBillingAddressInputFields !== null && !checkboxAddress) {
        let primaryBillingAddressStorage = primaryBillingAddressInputFields.map((primaryBillingAddressInputFields) => {
          if(primaryBillingAddressInputFields.name) {
            return {
              ...primaryBillingAddressInputFields,
              value: storageLocalAddressData[primaryBillingAddressInputFields.name]
            }
          }
        })
        setPrimaryBillingAddressInputFields(primaryBillingAddressStorage)
      }
    }
    
    const secondaryProductData = window.sessionStorage.getItem('secondary_selected_membership');
    if ( secondaryProductData !== null ) var secondaryStorageLocalProductData = JSON.parse(secondaryProductData);

    const secondaryPersonalData = window.sessionStorage.getItem('secondary_personal_details');
    if ( secondaryPersonalData !== null ) {
      var secondaryStorageLocalPersonalData = JSON.parse(secondaryPersonalData);

      let secondaryStoredData = secondaryInputFields.map((secondaryInputFields) => {
        if(secondaryInputFields.name) {
          return {
            ...secondaryInputFields,
            value: secondaryStorageLocalPersonalData[secondaryInputFields.name]
          }
        }
      })
      // setSecondaryInputFields(secondaryStoredData);
      setInputLanguages(setSecondaryInputFields, secondaryStoredData, languages)
    }
    
    const secondaryAddressData = window.sessionStorage.getItem('secondary_address_details');
    if ( secondaryAddressData !== null ) {
      var secondaryStorageLocalAddressData = JSON.parse(secondaryAddressData);
      // setSecondaryAddressInput(JSON.parse(secondaryAddressData))

      if(primarySecondaryAddressInputFields !== null) {
        let secondaryAddressStorage = primarySecondaryAddressInputFields.map((primarySecondaryAddressInputFields) => {
          if(primarySecondaryAddressInputFields.name) {
            return {
              ...primarySecondaryAddressInputFields,
              value: secondaryStorageLocalAddressData[primarySecondaryAddressInputFields.name]
            }
          }
        })
        setSecondaryPrimaryAddressInputFields(secondaryAddressStorage)

      }

      if(primarySecondaryBillingAddressInputFields !== null && !secondaryCheckboxAddress) {
        let secondaryBillingAddressStorage = primarySecondaryBillingAddressInputFields.map((primarySecondaryBillingAddressInputFields) => {
          if(primarySecondaryBillingAddressInputFields.name) {
            return {
              ...primarySecondaryBillingAddressInputFields,
              value: secondaryStorageLocalAddressData[primarySecondaryBillingAddressInputFields.name]
            }
          }
        })
        setSecondaryPrimaryBilliingAddressInputFields(secondaryBillingAddressStorage)
      }
    }
    

    if(storageLocalProductData !== undefined && isSecondaryMember) {

      const localstorageData = {
        'business_categories': {...bc},
        'members': [
          {
            "selected_product": {...storageLocalProductData},
            ...storageLocalPersonalData,
            ...storageLocalAddressData,
            "type_of_member": "primary_owner",
            "memberid": memberId,
            "card": isPrimaryDigitalCard,
            "isShown": true,
            "pmid": primaryPmid || "",
            "isQbr": isQbr
          },
          {
            "selected_product": {...secondaryStorageLocalProductData},
            ...secondaryStorageLocalPersonalData,
            ...secondaryStorageLocalAddressData,
            "type_of_member": "supp",
			      "memberid": secondaryMemberId,
            "card": isSecondaryDigitalCard,
            "isShown": true,
          }
        ],
        "hotelRIDOnlineKiosk" : queryParams.get('hotelRIDOnlineKiosk') ? queryParams.get('hotelRIDOnlineKiosk') : "",
        "apHotelEmployeeName" : queryParams.get('apHotelEmployeeName') ? queryParams.get('apHotelEmployeeName') : "",
        "hotelEmployee"       : queryParams.get('hotelEmployee') ? queryParams.get('hotelEmployee') : "",
        "apHotelEmployeeId"   : queryParams.get('apHotelEmployeeId') ? queryParams.get('apHotelEmployeeId') : "",
        "source"              : Helper.hotelDetected() ? "Hotel" : "Website",
        step
      }
      setLocalStorageDatas(localstorageData)
    } 
    
    
    else {
      const localstorageData = {
        'business_categories': {...bc},
        'members': [
          {
            "selected_product": {...storageLocalProductData},
            ...storageLocalPersonalData,
            ...storageLocalAddressData,
            "type_of_member": "primary_owner",
            "memberid": memberId,
            "card": isPrimaryDigitalCard,
            "isShown": true,
            "pmid": primaryPmid || ""
          },
        ],
        "hotelRIDOnlineKiosk" : queryParams.get('hotelRIDOnlineKiosk') ? queryParams.get('hotelRIDOnlineKiosk') : "",
        "apHotelEmployeeName" : queryParams.get('apHotelEmployeeName') ? queryParams.get('apHotelEmployeeName') : "",
        "hotelEmployee"       : queryParams.get('hotelEmployee') ? queryParams.get('hotelEmployee') : "",
        "apHotelEmployeeId"   : queryParams.get('apHotelEmployeeId') ? queryParams.get('apHotelEmployeeId') : "",
        "source"              : Helper.hotelDetected() ? "Hotel" : "Website",
        step
      }
      setLocalStorageDatas(localstorageData)
    }
  }  

  // Edit Button Review Step
  function editReview(item) {

    if(item.type_of_member === 'primary_owner') {
      setStep(1)
    } else if (item.type_of_member === 'supp') {
      setStep(2)
    }
    setProgress(Helper.getProgressBarWidth(step));
    setHeaderStepText()
  }

  // Header modal
  function handleShowModal(e) {
    e.preventDefault()
    setShowModal(true)
  }

  // Header modal
  function onCloseModal() {
    setShowModal(false)
  }
 
  // Inputs Fields Validation Check
  // For Both Primary and Secondary Members 
  function onFieldBlur(e){
    const name  = e.target.name
    const value = e.target.value;
    let message;
    let error;
    let valid;
    let checking;

    if(name === 'email'){
      if(value){
          if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)){
            message = languages.validateEmail ? languages.validateEmail : 'Please enter a valid email address.';
            error   = true;
            valid   = false;
          } else {
            valid    = false;
            error    = false;
            if(touched === true) {
              checking = true;              
              checkMemberExist({"email": value});
              setEmailChecking(true);
            }  
            
          }
      }
    }
    if(name === 'confirm_email'){
      var previousEmail;
      if(step === 4) {
        previousEmail = inputFields[0].value ? inputFields[0].value : '';
      } else if (step === 6) {
        previousEmail = secondaryInputFields[0].value ? secondaryInputFields[0].value : '';
      }
      if(value){
          if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)){
            message = languages.validateConfirmEmail ? languages.validateConfirmEmail : 'Please enter a valid email address.';
            error   = true;
          }else if(previousEmail !== value){
            error   = true;
            message = languages.validateEmailError ? languages.validateEmailError : 'Email Address does not match!';
          }else{
            message = '';
            error   = false;
            valid   = true;
          }
      }
    }
    if(name === 'first_name' || name === 'last_name'){
      const hasOnlyLetters = !!value.match(/^[a-zA-Z_'-. ]*$/i);
      if(!value){
        message = languages.fieldMissingErrorMessage ? languages.fieldMissingErrorMessage : 'This field is mandatory and must be filled out.';
        error   = true;
      } else if(!hasOnlyLetters) {
        message = languages.fieldContainsLatinCharactersMessage ? languages.fieldContainsLatinCharactersMessage : 'Please enter only latin characters';
        error   = true;
      } else{
        var validation = Helper.characterLimit(name, value);
        if(!validation){
          message = languages.validateCharacters ? languages.validateCharacters :'This field must not exceed 25 characters.';
          error   = true;
        }else{
          message = '';
          error   = false;
          valid   = true;
        }
      }
    }
    if( name === 'title'){
        message = '';
        error   = false;
        valid   = true;
    }

    let validationCheckedFields = inputFields.map((item) => {
      if(item.name === name) {
        if(item.name === 'email' && item.isError && !checking) {
          return {
            ...item
          }
        }else {
          return {
            ...item,
            isError  : error,
            message  : message,
            checking : checking,
            valid    : valid
          }
        }
      } else {
        return {
          ...item
        }
      }
    });

    let validationSecondaryCheckedFields = secondaryInputFields.map((item) => {
      if(item.name === name) {
        if(item.name === 'email' && item.isError && !checking) {
          return {
            ...item
          }
        }else {
          return {
            ...item,
            isError  : error,
            message  : message,
            checking : checking,
            valid    : valid
          }
        }
      } else {
        return {
          ...item
        }
      }
    });


    if(step === 4) {
      // setInputFields(validationCheckedFields);
      setInputLanguages(setInputFields, validationCheckedFields, languages)
    } else if (step === 6) {
      setSecondaryInputFields(validationSecondaryCheckedFields)
    }
  }

  // [Primary] Personal Details Submit [5]
  const personalDetailsSubmit = event => {
    event.preventDefault();
    let isValid = true;
    let memberCheck;
    const message     = languages.fieldMissingErrorMessage ? languages.fieldMissingErrorMessage :'This field is mandatory and must be filled out.';
    if(inputFields === null){
      isValid = false;
      memberCheck = inputFields.map((item) => {
        if(item.name === 'title') {
          return {
            ...item,
            isError: false,
            message: ''
          }
        }else{
            return {
              ...item,
              isError : true,
              message : message,
              valid   : false
            }
          }
      });
    }else{
      var email;
      var confirmEmail;
      inputFields.map((item) => {
        if(item.name === 'email' && item.value) {
          email = item.value;
        } 
        if(item.name === 'confirm_email' && item.value) {
          confirmEmail = item.value;
        }
      });
      memberCheck = inputFields.map((item) => {
        if(item.name === 'first_name' && !item.value) {
          return {
            ...item,
            isError : true,
            message : message
          }
        } else if(item.name === 'last_name' && !item.value) {
          return {
            ...item,
            isError : true,
            message : message
          }
        } else if(item.name === 'email' && !item.value) {
          return {
            ...item,
            isError : true,
            message : message
          }
        } else if(item.name === 'confirm_email' && !item.value) {
            return {
              ...item,
              isError : true,
              message : message
            }
        } else if(item.name === 'confirm_email' && item.value && confirmEmail != email) {
            return {
              ...item,
              isError : true,
              message : languages.validateEmailError ? languages.validateEmailError : "Email Address does not match"
            }
        } else if(item.name === 'phone_number' && !item.value) {
          return {
            ...item,
            isError: true,
            message: languages.validatePhone ? languages.validatePhone : "This field must contain a valid phone number"
          }
        } else if(item.name === 'phone_number' && item.value.leahNum && item.value.leahNum.length < 10) { 
          return {
            ...item,
            isError: true,
            message: languages.validatePhone ? languages.validatePhone : "This field must contain a valid phone number"
          }
        } else if(item.isError) {
          return {
            ...item
          }
        } else {
          return {
            ...item,
            isError: false,
            message: ''
          }
        }
      });
    }

    inputFields.map((item) => {
      if(item.isError) {
        isValid = false;
      }
    });

    let personalArr = []
    let storedData = inputFields.map((inputFields) => {
      if(inputFields.name) {
        return {
          name: inputFields.name,
          value: inputFields.value
        }
      }
    })

    personalArr.push(storedData)
    var input_data = {}
    for(var i = 0; i < personalArr[0].length; i++) {
      input_data[personalArr[0][i].name] = personalArr[0][i].value;
    }   
    if (!isValid || inputFields === null || input_data.email === '' || input_data.confirm_email === '' || input_data.first_name === '' || input_data.last_name === '' || input_data.phone_number === '' || input_data.phone_number.leahNum === '' || input_data.phone_number.leahNum.length < 10 || input_data.email != input_data.confirm_email){
      // setInputFields(memberCheck);
      setInputLanguages(setInputFields, memberCheck, languages)
    } else {
      sessionStorage.setItem('personal_details', JSON.stringify(input_data));
      TagManager.dataLayer(Helper.gtmGeneralCheckoutStep('checkoutstep_three', getPath(step), 3))
      goNextStep();
    }  
  }

  // [Secondary] Personal Details Submit
  const secondaryPersonalDetailsSubmit = event => {
    event.preventDefault();
    let isValid = true;
    let memberCheck;
    const message = languages.fieldMissingErrorMessage ? languages.fieldMissingErrorMessage : 'This field is mandatory and must be filled out.';

    if (secondaryInputFields[0].value !== secondaryInputFields[1].value) {
      memberCheck = secondaryInputFields.map((item) => {
        if(item.name === 'confirm_email') {
          return {
            ...item,
            isError: true,
            valid: false,
            message: languages.validateEmailError ? languages.validateEmailError : "Email Address does not match!"
          }
        } else {
          return {
            ...item,
            isError: false,
            message: ''
          }
        }
      });
      setSecondaryInputFields(secondaryInputFields);
      return false;
    }

    if (inputFields[0].value === secondaryInputFields[0].value) {
      memberCheck = secondaryInputFields.map((item) => {
        if(item.name === 'email') {
          return {
            ...item,
            isError: true,
            valid: false,
            message: languages.validateBothEmail ? languages.validateBothEmail : "You cannot use the same email address as primary member"
          }
        } else {
          return {
            ...item,
            isError: false,
            message: ''
          }
        }
      });
      setSecondaryInputFields(memberCheck);
      return false;
    }

    memberCheck = secondaryInputFields.map((item) => {
      if(item.name === 'first_name' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'last_name' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'email' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'confirm_email' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'phone_number' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'phone_number' && item.value.localNumber && item.value.leahNum.length < 10) {
        return {
          ...item,
          isError: true,
          message: languages.validatePhone ? languages.validatePhone : "This field must contain a valid phone number"
        }
      } else if(item.isError) {
        return {
          ...item
        }
      } else {
        return {
          ...item,
          isError : false,
          message : ''
        }
      }
    });

    secondaryInputFields.map((item) => {
      if(item.isError) {
        isValid = false;
      }
    });
  
    let secondaryArr = []
    let storedData = secondaryInputFields.map((secondaryInputFields) => {
      if(secondaryInputFields.name) {
        return {
          name: secondaryInputFields.name,
          value: secondaryInputFields.value
        }
      }
    })
  
    secondaryArr.push(storedData)
    var secondary_input_data = {}
    for(var i = 0; i < secondaryArr[0].length; i++) {
      secondary_input_data[secondaryArr[0][i].name] = secondaryArr[0][i].value;
    }
  
    if (!isValid || secondaryInputFields === null || secondary_input_data.email === '' || secondary_input_data.confirm_email === '' || secondary_input_data.first_name === '' || secondary_input_data.last_name === '' || secondary_input_data.phone_number === '' || secondary_input_data.phone_number.leahNum === '' || secondary_input_data.phone_number.leahNum.length < 10){
      setSecondaryInputFields(memberCheck);
    } else {
      sessionStorage.setItem('secondary_personal_details', JSON.stringify(secondary_input_data));
      TagManager.dataLayer(Helper.gtmGeneralCheckoutStep('checkoutstep_five', getPath(step), 5))
      goNextStep()
    }
  }

  // Email Checker Function 
  const checkMemberExist = (params) => {
    let valid;
    let error; 
    let message;
    setMemberStatus(false);

    if(inputFields || secondaryInputFields){
    ApiService.memberStatus(params, locationDatas.emailCheck)
    .then(res => res.json())
    .then(
    (result) => {
      if(result.errorMessage) {
        valid   = false;
        error   = true;
        message = languages.validateEmailCheck ? languages.validateEmailCheck : 'Something went wrong. Please try again.';
      } else if(result && result.status_text && (result.status_text === "MEMBER-Current Member" || result.status_text === "MEMBER-In Progress")) {
        valid   = false;
        error   = true;
        message = languages.emailCurrentlyBeingProcessMessage ? languages.emailCurrentlyBeingProcessMessage : 'The email is in use by an existing member. Please login to continue or contact Member Services for further assistance.';
      } else {
        if(result.status_text === "MEMBER-Lapsed Member" || result.status_text === "MEMBER-Pending Member" || !result.memberid) {
        }
        valid   = true;
        error   = false;
        message = '';
      }

      if(inputFields && step === 4) {
        let memberCheck = inputFields.map((item) => {
          if(item.name === 'email') {
            return {
              ...item,
              checking : false,
              valid    : valid,
              message  : message,
              isError  : error 
            }
          } else {
            return {
              ...item
            }
          }
        });
        // setInputFields(memberCheck);
        setInputLanguages(setInputFields, memberCheck, languages)
        setEmailChecking(false);
        setMemberId(result.memberid);
      }
      if(secondaryInputFields && step === 6) {
        let memberCheck = secondaryInputFields.map((item) => {
          if(item.name === 'email') {
            return {
              ...item,
              checking : false,
              valid    : valid,
              message  : message,
              isError    : error 
            }
          } else {
            return {
              ...item
            }
          }
        });
        setSecondaryInputFields(memberCheck);
        setEmailChecking(false);
        setSecondaryMemberId(result.memberid);
      }
      setTouched(false)
      setMemberStatus(true);
    },
    () => {
        setMemberStatus(false)
    })}
  }

  var isCountryIndiaPrimary;

  if(locationDatas.country === 'in' || locationDatas.country === 'IN') {
    isCountryIndiaPrimary = inputFields;
  } else {
    isCountryIndiaPrimary = inputFields.filter(x => x.name !== "tax_number");
  }

  // [Primary] - Input state changes
  function inputChange(e) {
    var inputName  = e.target.name
    var inputValue = e.target.value;  
    let storedData = isCountryIndiaPrimary.map((inputFields) => {
      if(inputFields.name === inputName) {
        return {
          ...inputFields,
          value: inputValue
        }
      } 
      else {
        return {
          ...inputFields
        }
      }
    })
    // setInputFields(storedData)
    setInputLanguages(setInputFields, storedData, languages)
    setTouched(true)
  }

  function inputPhoneChange(inputVal, name) {
    var dialCode    = name.dialCode;                               
    var localNumber = inputVal.slice(dialCode.length)   
    var countryCodeValLeading0 = parseInt(localNumber, 10)   
    var leahNum = dialCode + countryCodeValLeading0;                  
    var phoneNum = '+' + inputVal;
    var validatedPhoneNum = phone(phoneNum, {strictDetection: true});


    const phoneObj = {
      ...validatedPhoneNum,
      localNumber,              // ex. 045 XXX XXXX
      countryCodeValLeading0,   // ex. 45 XXX XXXX' 
      leahNum,                  // ex. 61 45 XXX XXXX
      dialCode,                  // ex. 61
      inputVal,
    }

    let storedData = isCountryIndiaPrimary.map((inputFields) => {
      if(inputFields.name === 'phone_number') {
        if(inputVal.length < 10){
          return {
            ...inputFields,
            value   : phoneObj,
            valid   : false,
            isError : true,
            message : languages.validatePhone ? languages.validatePhone : 'This field must contain a valid phone number'
          }
        }else{
          return {
            ...inputFields,
            value   : phoneObj,
            valid   : true,
            isError : false,
            message : ''
          }
        }
      } else {
        return {
          ...inputFields
        }
      }
    })
    // setInputFields(storedData)
    setInputLanguages(setInputFields, storedData, languages)
    
  }

  var isCountryIndiaSecondary;

  if(locationDatas.country === 'in' || locationDatas.country === 'IN') {
    isCountryIndiaSecondary = secondaryInputFields;
  } else {
    isCountryIndiaSecondary = secondaryInputFields.filter(x => x.name !== "tax_number");
  }

  // [Primary] - Input state changes
  function secondaryInputChange(e) {
    var inputName  = e.target.name
    var inputValue = e.target.value;   

    let storedData = isCountryIndiaSecondary.map((secondaryInputFields) => {
      if(secondaryInputFields.name === inputName) {
        return {
          ...secondaryInputFields,
          value   : inputValue
        }
      } else {
        return {
          ...secondaryInputFields
        }
      }
    })
    setSecondaryInputFields(storedData)
    setTouched(true)
    // setSecondaryPersonalDetailsInput(prevState => ({...prevState, [name]: value}))
  }

  function secondaryInputPhoneChange(inputVal, name, country) {
    var dialCode    = name.dialCode;                            
    var localNumber = inputVal.slice(dialCode.length)   
    var countryCodeValLeading0 = parseInt(localNumber, 10)   
    var leahNum = dialCode + countryCodeValLeading0;                       
    var phoneNum = '+' + inputVal;
    var validatedPhoneNum = phone(phoneNum, {strictDetection: true});  


    const phoneObj = {
      ...validatedPhoneNum,
      localNumber,              // ex. 045 XXX XXXX
      countryCodeValLeading0,   // ex. 45 XXX XXXX' 
      leahNum,                  // ex. 61 45 XXX XXXX
      dialCode,                 // ex. 61
      inputVal
    }

    let storedData = isCountryIndiaSecondary.map((secondaryInputFields) => {
      if(secondaryInputFields.name === 'phone_number') {
        if(inputVal.length < 10) { 
          return {
            ...secondaryInputFields,
            value   : phoneObj,
            valid   : false,
            isError : true,
            message : languages.validatePhone ? languages.validatePhone : 'This field must contain a valid phone number'
          }
        }else{
          return {
            ...secondaryInputFields,
            value   : phoneObj,
            valid   : true,
            isError : false,
            message : ''
          }
        }
      } else {
        return {
          ...secondaryInputFields
        }
      }
    })
    setSecondaryInputFields(storedData)
  }

  // ADDRESS [STEP] 
  // STEP
  // PRIMARY
  const googleOptions = {
    fields: ["address_components", "geometry", "icon", "name"],
    types: ["address"]
  };

  useEffect(()=> {
    googleAPIAddress()
    secondaryGoogleAPIAddress()
  }, [step])

  // [Primary] Address submit
  function onSubmitAddressDetails(e) {
    e.preventDefault();
    const message     = languages.fieldMissingErrorMessage ? languages.fieldMissingErrorMessage : 'This field is mandatory and must be filled out.';
    let addressValidate = primaryAddressInputFields.map((item) => {
      if(item.name === 'address_line_1' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'city' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'state' && !item.value && item.required) {
        return {
            ...item,
            isError: true,
            message: message
          }
      } else if(item.name === 'postcode' && !item.value && isPrimaryPostalRequired) {
        return {
            ...item,
            isError: true,
            message: message
          }
      } else if(item.name === 'country' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else {
        return {
          ...item,
          isError: false,
          message: ''
        }
      }
    });
    let addressArr = []
    let shippingArr = []
    let storedData = primaryAddressInputFields.map((primaryAddressInputFields) => {
      if(primaryAddressInputFields.name) {
        return {
          name: primaryAddressInputFields.name,
          value: primaryAddressInputFields.value,
        }
      }
    })
    addressArr.push(storedData)
    var input_data = {}
    for(var i = 0; i < addressArr[0].length; i++) {
      input_data[addressArr[0][i].name] = addressArr[0][i].value;
    }

    let billingAddressValidate = primaryBillingAddressInputFields.map((item) => {
      if(item.name === 'billing_address_line_1' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'billing_city' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'billing_state' && !item.value && item.required) {
        return {
            ...item,
            isError: true,
            message: message
          }
      } else if(item.name === 'billing_postcode' && !item.value && isPrimaryPostalRequired) {
        return {
            ...item,
            isError: true,
            message: message
          }
      } else if(item.name === 'billing_country' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else {
        return {
          ...item,
          isError: false,
          message: ''
        }
      }
    });

    let storedBillingData = primaryBillingAddressInputFields.map((primaryBillingAddressInputFields) => {
      if(primaryBillingAddressInputFields.name) {
        return {
          name: primaryBillingAddressInputFields.name,
          value: primaryBillingAddressInputFields.value
        }
      }
    })
    shippingArr.push(storedBillingData)
    var input_shipping_data = {}
    for(var i = 0; i < shippingArr[0].length; i++) {
      input_shipping_data[shippingArr[0][i].name] = shippingArr[0][i].value;
    }
    let addressDetails;
    if(checkboxAddress) {
      var shipping = {
        billing_address_line_1: input_data.address_line_1,
        billing_address_line_2: input_data.address_line_2,
        billing_address_line_3: input_data.address_line_3,
        billing_city: input_data.city,
        billing_country: input_data.country,
        billing_postcode: input_data.postcode,
        billing_state: input_data.state,
      }
      addressDetails = {
        ...input_data,
        ...shipping
      }
    } else {
    addressDetails = {
        ...input_data,
        ...input_shipping_data
      }
    }  

    function validateAddress() {
      setPrimaryAddressInputFields(addressValidate)
      setPrimaryBillingAddressInputFields(billingAddressValidate)      
    }

    let stateRequiredValidate = primaryAddressInputFields.filter(a => a.name === 'state')
    let stateBillingRequiredValidate = primaryBillingAddressInputFields.filter(a => a.name === 'billing_state')


    var primaryAddressStatus = addressDetails === null || addressDetails.address_line_1 === '' || addressDetails.city === '' || (stateRequiredValidate[0].required ? addressDetails.state === '' : false) || (isPrimaryPostalRequired === true ? addressDetails.postcode === '' : false) || addressDetails.country === '';
    var primaryBillingAddressStatus = addressDetails.billing_address_line_1 === '' || addressDetails.billing_city === '' || (stateBillingRequiredValidate[0].required ? addressDetails.billing_state === '' : false) || (isPrimaryBillingPostalRequired === true ? addressDetails.billing_postcode === '' : false) || addressDetails.billing_country === '';


    if (primaryAddressStatus || (checkboxAddress ? false : primaryBillingAddressStatus)){
      findMyaddessInGoogle ? setGoogleAddressEmpty(true) : validateAddress();
    } else {
      validateAddress()
      sessionStorage.setItem('address_details', JSON.stringify(addressDetails));
      TagManager.dataLayer(Helper.gtmGeneralCheckoutStep('checkoutstep_four', getPath(step), 4))
      goNextStep();
    }
  }

  // [Secondary] submit
  function onSubmitSecondaryAddressDetails(e) {
    const message     = languages.fieldMissingErrorMessage ? languages.fieldMissingErrorMessage : 'This field is mandatory and must be filled out.';
    let addressValidate = primarySecondaryAddressInputFields.map((item) => {
      if(item.name === 'address_line_1' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'city' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'state' && !item.value && item.required) {
        return {
            ...item,
            isError: true,
            message: message
          }
      } else if(item.name === 'postcode' && !item.value && isSecondaryPostalRequired) {
        return {
            ...item,
            isError: true,
            message: message
          }
      } else if(item.name === 'country' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else {
        return {
          ...item,
          isError: false,
          message: ''
        }
      }
    });
    let addressArr = []
    let billingArr = []
    let storedData = primarySecondaryAddressInputFields.map((primarySecondaryAddressInputFields) => {
      if(primarySecondaryAddressInputFields.name) {
        return {
          name: primarySecondaryAddressInputFields.name,
          value: primarySecondaryAddressInputFields.value
        }
      }
    })
    addressArr.push(storedData)
    var input_data = {}
    for(var i = 0; i < addressArr[0].length; i++) {
      input_data[addressArr[0][i].name] = addressArr[0][i].value;
    }

    let billingAddressValidate = primarySecondaryBillingAddressInputFields.map((item) => {
      if(item.name === 'billing_address_line_1' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'billing_city' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else if(item.name === 'billing_state' && !item.value && item.required) {
        return {
            ...item,
            isError: true,
            message: message
          }
      } else if(item.name === 'billing_postcode' && !item.value && isPrimaryPostalRequired) {
        return {
            ...item,
            isError: true,
            message: message
          }
      } else if(item.name === 'billing_country' && !item.value) {
        return {
          ...item,
          isError: true,
          message: message
        }
      } else {
        return {
          ...item,
          isError: false,
          message: ''
        }
      }
    });

    let storedBillingData = primarySecondaryBillingAddressInputFields.map((primarySecondaryBillingAddressInputFields) => {
      if(primarySecondaryBillingAddressInputFields.name) {
        return {
          name: primarySecondaryBillingAddressInputFields.name,
          value: primarySecondaryBillingAddressInputFields.value
        }
      }
    })
    billingArr.push(storedBillingData)
    var input_billing_data = {}
    for(var i = 0; i < billingArr[0].length; i++) {
      input_billing_data[billingArr[0][i].name] = billingArr[0][i].value;
    }
    let addressDetails;
    if(secondaryCheckboxAddress) {
      var billing = {
        billing_address_line_1: input_data.address_line_1,
        billing_address_line_2: input_data.address_line_2,
        billing_address_line_3: input_data.address_line_3,
        billing_city: input_data.city,
        billing_country: input_data.country,
        billing_postcode: input_data.postcode,
        billing_state: input_data.state,
      }
      addressDetails = {
        ...input_data,
        ...billing
      }
    } else {
    addressDetails = {
        ...input_data,
        ...input_billing_data
      }
    }  

    function validateAddress() {
      setSecondaryPrimaryAddressInputFields(addressValidate)
      setSecondaryPrimaryBilliingAddressInputFields(billingAddressValidate)      
    }

    let stateRequiredValidate = primarySecondaryAddressInputFields.filter(a => a.name === 'state')
    let stateBillingRequiredValidate = primarySecondaryBillingAddressInputFields.filter(a => a.name === 'billing_state')

    var primaryAddressStatus = addressDetails === null || addressDetails.address_line_1 === '' || addressDetails.city === '' || (stateRequiredValidate[0].required ? addressDetails.state === '' : false) || (isPrimaryPostalRequired === true ? addressDetails.postcode === '' : false) || addressDetails.country === '';
    var primaryBillingAddressStatus = addressDetails.billing_address_line_1 === '' || addressDetails.billing_city === '' || (stateBillingRequiredValidate[0].required ? addressDetails.billing_state === '' : false) || (isPrimaryPostalRequired === true ? addressDetails.billing_postcode === '' : false) || addressDetails.billing_country === '';
  
    if (primaryAddressStatus || (secondaryCheckboxAddress ? false : primaryBillingAddressStatus)){
      secondaryFindMyaddessInGoogle ? setSecondaryGoogleAddressEmpty(true) : validateAddress();
    } else {
      validateAddress();
      sessionStorage.setItem('secondary_address_details', JSON.stringify(addressDetails));
      TagManager.dataLayer(Helper.gtmGeneralCheckoutStep('checkoutstep_six', getPath(step), 6))
      goNextStep();
    }
  }

  // [Primary] API Address primary

  function googleAPIAddress() {
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      googleOptions
    );

    autoCompleteRef.current.addListener("place_changed", () => {
      const place = autoCompleteRef.current.getPlace();
      let addressData = {};
      addressData.address_line_1 ='';
      place.address_components.map((component) => { 
        const componentType = component.types[0];
        switch (componentType) {
          case "subpremise" : {
            addressData.address_line_1 = component.long_name + ', ';
            break;
          }

          case "street_number": {
              addressData.address_line_1 += component.long_name + ' ';
              break;
          }
    
          case "route": {
              addressData.address_line_1 += component.long_name;
              break;
          }
      
          case "postal_code": {
              addressData.postcode = component.long_name;
              break;
          }
      
          case "locality":
              addressData.city = component.long_name;
              break;
      
          case "administrative_area_level_1": {
              addressData.state = component.short_name;
              break;
          }
      
          case "country":
              addressData.country = component.long_name;
              break;
          }
      });

      let storedData = primaryAddressInputFields.map((primaryAddressInputFields) => {
        if(primaryAddressInputFields.name === 'address_line_2') {
          return {
            ...primaryAddressInputFields,
            value: addressData.address_line_2
          }
        } 
        if(primaryAddressInputFields.name === 'address_line_3') {
          return {
            ...primaryAddressInputFields,
            value: addressData.address_line_3
          }
        } 
        if(primaryAddressInputFields.name === 'address_line_1') {
          return {
            ...primaryAddressInputFields,
            value: addressData.address_line_1
          }
        } 

        if(primaryAddressInputFields.name === 'city') {
          return {
            ...primaryAddressInputFields,
            value: addressData.city
          }
        }

        if(primaryAddressInputFields.name === 'country') {
          return {
            ...primaryAddressInputFields,
            value: addressData.country
          }
        }

        if(primaryAddressInputFields.name === 'postcode') {
          return {
            ...primaryAddressInputFields,
            value: addressData.postcode
          }
        }

        if(primaryAddressInputFields.name === 'state') {
          return {
            ...primaryAddressInputFields,
            value: addressData.state
          }
        }
        
        else {
          return {
            ...primaryAddressInputFields
          }
        }
      })
      setPrimaryAddressInputFields(storedData)
      setFindMyaddessInGoogle(!findMyaddessInGoogle);
      });
  }

  // [Primary] API Address primary
  function secondaryGoogleAPIAddress() {
    autoCompleteRef2.current = new window.google.maps.places.Autocomplete(
      secondaryInputRef.current,
      googleOptions
    );

    autoCompleteRef2.current.addListener("place_changed", async function () {
      const place = await autoCompleteRef2.current.getPlace();
      let secondaryAddressData            = {};
      secondaryAddressData.address_line_1 = '';
      place.address_components.map((component) => { 
      const componentType = component.types[0];
      switch (componentType) {
        case "subpremise" : {
          secondaryAddressData.address_line_1 = component.long_name + ', ';
          break;
        }
        case "street_number": {
            secondaryAddressData.address_line_1 += component.long_name + ' ';
            break;
        }
    
        case "route": {
            secondaryAddressData.address_line_1 += component.short_name;
            break;
        }
    
        case "postal_code": {
            secondaryAddressData.postcode = component.long_name;
            break;
        }
    
        case "locality":
            secondaryAddressData.city = component.long_name;
            break;
    
        case "administrative_area_level_1": {
            secondaryAddressData.state = component.short_name;
            break;
        }
    
        case "country":
            secondaryAddressData.country = component.long_name;
            break;
        }
      });
      let storedData = primaryAddressInputFields.map((primaryAddressInputFields) => {
        if(primaryAddressInputFields.name === 'address_line_1') {
          return {
            ...primaryAddressInputFields,
            value: secondaryAddressData.address_line_1
          }
        } 
        if(primaryAddressInputFields.name === 'address_line_2') {
          return {
            ...primaryAddressInputFields,
            value: secondaryAddressData.address_line_2
          }
        } 

        if(primaryAddressInputFields.name === 'address_line_3') {
          return {
            ...primaryAddressInputFields,
            value: secondaryAddressData.address_line_3
          }
        } 

        if(primaryAddressInputFields.name === 'city') {
          return {
            ...primaryAddressInputFields,
            value: secondaryAddressData.city
          }
        }

        if(primaryAddressInputFields.name === 'country') {
          return {
            ...primaryAddressInputFields,
            value: secondaryAddressData.country
          }
        }

        if(primaryAddressInputFields.name === 'postcode') {
          return {
            ...primaryAddressInputFields,
            value: secondaryAddressData.postcode
          }
        }

        if(primaryAddressInputFields.name === 'state') {
          return {
            ...primaryAddressInputFields,
            value: secondaryAddressData.state
          }
        }
        
        else {
          return {
            ...primaryAddressInputFields
          }
        }
      })
      setSecondaryPrimaryAddressInputFields(storedData)
      setSecondaryFindMyaddessInGoogle(!secondaryFindMyaddessInGoogle);
      });
  }

  // [Primary] Address - Input state changes
  function primaryAddressInput(e) {
    var inputName = e.target.name
    var inputValue = e.target.value; 
    let storedData = primaryAddressInputFields.map((primaryAddressInputFields) => {

     

      if(primaryAddressInputFields.name === inputName) {
        return {
          ...primaryAddressInputFields,
          value: inputValue
        }
      } 
      
      else {
        return {
          ...primaryAddressInputFields
        }
      }
    })
    setPrimaryAddressInputFields(storedData)
  }

  // [Primary] Address - Input state changes
  function primaryBillingAddressInput(e) {
    var inputName = e.target.name
    var inputValue = e.target.value; 
    let storedData = primaryBillingAddressInputFields.map((primaryBillingAddressInputFields) => {
      if(primaryBillingAddressInputFields.name === inputName) {
        return {
          ...primaryBillingAddressInputFields,
          value: inputValue
        }
      } else {
        return {
          ...primaryBillingAddressInputFields
        }
      }
    })
    setPrimaryBillingAddressInputFields(storedData)
  }

  // [Secondary] Address - Input state changes
  function handleSecondaryAddressInput(e) {
    var inputName = e.target.name
    var inputValue = e.target.value; 
    let storedData = primarySecondaryAddressInputFields.map((primarySecondaryAddressInputFields) => {
      if(primarySecondaryAddressInputFields.name === inputName) {
        return {
          ...primarySecondaryAddressInputFields,
          value: inputValue
        }
      } else {
        return {
          ...primarySecondaryAddressInputFields
        }
      }
    })
    setSecondaryPrimaryAddressInputFields(storedData)
  }

  // [Secondary] Address - Input state changes
  function handleSecondaryBillingAddressInput(e) {
    var inputName = e.target.name
    var inputValue = e.target.value;    
    let storedData = primarySecondaryBillingAddressInputFields.map((primarySecondaryBillingAddressInputFields) => {
      if(primarySecondaryBillingAddressInputFields.name === inputName) {
        return {
          ...primarySecondaryBillingAddressInputFields,
          value: inputValue
        }
      } else {
        return {
          ...primarySecondaryBillingAddressInputFields
        }
      }
    })
    setSecondaryPrimaryBilliingAddressInputFields(storedData)
  }

  // [primary] checkbox
  function handleCheckboxAddress() {
    setCheckboxAddress(!checkboxAddress)
  }

  // [Secondary] checkbox
  function handleSecondaryCheckboxAddress() {
    setSecondaryCheckboxAddress(!secondaryCheckboxAddress)
  }
  
  // [Address] Address Step
  function addressFind() {
    setFindMyaddessInGoogle(!findMyaddessInGoogle)
  }

  // [Address] Address Step
  function secondaryAddressFind() {
    setSecondaryFindMyaddessInGoogle(!secondaryFindMyaddessInGoogle)
  }


  if (!isLoaded) {
    return(<LoadingScreen /> )
  } else if (error) {
    return (
        <div className='App structure'>
            <div className='container mx-auto xs:px-3.5 laptop:px-4'>
                <div className='register-wrapper'>
                    <ErrorComponent errorMessage ={error} />
                </div>
            </div>
        </div>
      )
  } else {
      return (
        <>
          <div className='App structure'>
              <div className='container mx-auto xs:px-3.5 laptop:px-4'>

                {/* <Button onClick={handleShowModal}>
                  Toggle modal
                </Button> */}

                  <div className='register-wrapper'>
                      <div className='progress-bar'>
                        <Progress className='progressbar' progress={progress} />
                      </div>

                      <Header 
                        goPreviousStep  = {goPreviousStep}
                        step            = {step}
                        headerText      = {headerText}
                        languages       = {languages}
                        productError    = {productError}
                        handleShowModal = {handleShowModal}
                        isUserLogged    = {isUserLogged}
                        locationDatas   = {locationDatas}
                      />

                      <div className='dynamic-component xs:pt-2 tablet:pt-4'> 
                        {/* Static Step 1  */}
                        {isLoaded && isProductLoaded ?
                          <ProductStep 
                            currentStep          = {step}
                            languages            = {languages}
                            locationData         = {locationDatas}
                            products             = {products}
                            selectMembership     = {selectMembership}
                            isProductLoaded      = {isProductLoaded}
                            error                = {productError}
                            locationDataCurrency = {locationDataCurrency}
                            stepNo               = {1}
                            couponObj            = {couponData}
                            isUserLogged         = {isUserLogged}
                            businessCategories   = {businessCategories}
                          />
                        : null}

                        {isLoaded && isProductLoaded && secondaryProducts ?
                          <SecondaryProductStep 
                            currentStep          = {step}
                            languages            = {languages}
                            locationData         = {locationDatas}
                            products             = {secondaryProducts}
                            selectMembership     = {selectSecondaryMembership}
                            isProductLoaded      = {isProductLoaded}
                            error                = {productError}
                            locationDataCurrency = {locationDataCurrency}
                            goNextStep           = {goNextStep}
                            stepNo               = {2}
                          />
                          : null}

                        {/* Static Step 2 */}
                        { Helper.isQbr && (
                          <QbrEligibilityStep 
                            currentStep                  = {step}
                            validateQbr                  = {validateQbr}
                            QBRinput                     = {QBRinput}
                            isQBRError                   = {isQBRError}
                            QBRmessage                   = {QBRmessage}
                            showQBRTerms                 = {showQBRTerms}
                            inputQBREligibilityEl        = {inputQBREligibilityEl}
                            checkBoxConsentQBR           = {checkBoxConsentQBR }
                            checkBoxTermsQBR             = {checkBoxTermsQBR}
                            checkBoxContactInfoQBR       = {checkBoxContactInfoQBR}
                            handleCheckBoxConsentQBR     = {handleCheckBoxConsentQBR}
                            handleCheckBoxTermsQBR       = {handleCheckBoxTermsQBR}
                            handleCheckBoxContactInfoQBR = {handleCheckBoxContactInfoQBR}
                            inputQBRChange               = {inputQBRChange}
                            showCheckBoxTermsTermsError  = {showCheckBoxTermsTermsError}
                            languages                    = {languages}
                            locationData                 = {locationDatas}
                            goNextStep                   = {goNextStep}
                            stepNo                       = {3}
                          />  
                        )}

                        <PersonalDetailStep 
                          currentStep           = {step}
                          languages             = {languages}
                          locationData          = {locationDatas}
                          goNextStep            = {goNextStep}
                          onFieldBlur           = {onFieldBlur}
                          inputChange           = {inputChange}
                          inputPhoneChange      = {inputPhoneChange}
                          inputPersonalEl       = {inputPersonalEl}
                          personalDetailsSubmit = {personalDetailsSubmit}
                          taxNumberIN           = {true}
                          inputFields           = {isCountryIndiaPrimary}
                          stepNo                = {4}
                          emailChecking         = {emailChecking}
                          // inputFields           = {inputFields}
                        />

                        <AddressStep 
                          currentStep                = {step}
                          languages                  = {languages}
                          locationData               = {locationDatas}
                          goNextStep                 = {goNextStep}
                          findMyaddessInGoogle       = {findMyaddessInGoogle}
                          primaryAddressInput        = {primaryAddressInput}
                          primaryBillingAddressInput = {primaryBillingAddressInput}
                          addressFind                = {addressFind}
                          inputAddressEl             = {inputAddressEl}
                          inputAddressBillingEl      = {inputAddressBillingEl}
                          inputFields                = {primaryAddressInputFields}
                          handleCardCheckBox         = {handleCardCheckBox}
                          isPrimaryDigitalCard       = {isPrimaryDigitalCard}
                          billingAddress             = {primaryBillingAddressInputFields}
                          onSubmitAddressDetails     = {onSubmitAddressDetails}
                          handleCheckboxAddress      = {handleCheckboxAddress}
                          localStorageDatas          = {localStorageDatas}
                          checkboxAddress            = {checkboxAddress}
                          inputRef                   = {inputRef}
                          stepNo                     = {5}
                          options                    = {googleOptions}
                          autoCompleteRef            = {autoCompleteRef}
                          googleAddressEmpty         = {googleAddressEmpty}
                        />

                        {isSecondaryMember &&
                          <SecondaryPersonalDetailStep 
                            currentStep                    = {step}
                            languages                      = {languages}
                            locationData                   = {locationDatas}
                            inputSecondaryPersonalEl       = {inputSecondaryPersonalEl}
                            taxNumberIN                    = {true}
                            goNextStep                     = {goNextStep}
                            onFieldBlur                    = {onFieldBlur}
                            secondaryInputChange           = {secondaryInputChange}
                            secondaryInputPhoneChange      = {secondaryInputPhoneChange}
                            secondaryInputFields           = {isCountryIndiaSecondary}
                            secondaryPersonalDetailsSubmit = {secondaryPersonalDetailsSubmit}
                            stepNo                         = {6}
                            emailChecking                  = {emailChecking}
                        />}

                        {isSecondaryMember && 
                          <SecondaryAddressStep 
                            currentStep                        = {step}
                            languages                          = {languages}
                            locationData                       = {locationDatas}
                            goNextStep                         = {goNextStep}
                            handleSecondaryAddressInput        = {handleSecondaryAddressInput}
                            handleSecondaryBillingAddressInput = {handleSecondaryBillingAddressInput}
                            secondaryFindMyaddessInGoogle      = {secondaryFindMyaddessInGoogle}
                            secondaryAddressFind               = {secondaryAddressFind}
                            inputSecondaryAddressEl            = {inputSecondaryAddressEl}
                            inputSecondaryAddressBillingEl     = {inputSecondaryAddressBillingEl}
                            inputFields                        = {primarySecondaryAddressInputFields}
                            billingAddress                     = {primarySecondaryBillingAddressInputFields}
                            onSubmitAddressDetails             = {onSubmitSecondaryAddressDetails}
                            handleSecondaryCheckboxAddress     = {handleSecondaryCheckboxAddress}
                            secondaryCheckboxAddress           = {secondaryCheckboxAddress}
                            secondaryInputRef                  = {secondaryInputRef}
                            handleCardCheckBox                 = {handleCardCheckBox}
                            isSecondaryDigitalCard             = {isSecondaryDigitalCard}
                            localStorageDatas                  = {localStorageDatas}
                            stepNo                             = {7}
                            options                            = {googleOptions}
                            autoCompleteRef2                   = {autoCompleteRef2}
                            secondaryGoogleAddressEmpty        = {secondaryGoogleAddressEmpty}
                          />}

                        <ReviewStep 
                          currentStep         = {step}
                          languages           = {languages}
                          locationData        = {locationDatas}
                          localStorageDatas   = {localStorageDatas}
                          goNextStep          = {goNextStep}
                          editReview          = {editReview}
                          // termsLink={TERMS_CONDITIONS_LINK}
                          checkBoxTerms       = {checkBoxTerms}
                          readMeTerms         = {readMeTerms}
                          handleCheckBoxTerms = {handleCheckBoxTerms}
                          handleCardCheckBox  = {handleCardCheckBox}
                          isRenewalPage       = {false}
                          isExpress           = {false} // only for express-checkout
                          handleShowList      = {handleShowList}
                          inputPromoEl        = {inputPromoEl}
                          memberId            = {memberId}
                          removeProduct       = {removeProduct}
                          isSecondaryMember   = {isSecondaryMember}
                          stepNo              = {8}
                          memberCreationError = {memberCreationError}
                          couponObj           = {couponData}
                          isUserLogged        = {isUserLogged}
                          businessCategories  = {businessCategories}
                          // termsLink={TERMS_CONDITIONS_LINK}
                          // cardCheckBox={cardCheckBox}
                        />

                        <PaymentStep 
                          currentStep       = {step}
                          languages         = {languages}
                          locationData      = {locationDatas}
                          localStorageDatas = {localStorageDatas}
                          goNextStep        = {processPayment}
                          stepNo            = {9}
                          isRenewalPage       = {false}
                          couponObj         = {couponData}
                          isUserLogged      = {isUserLogged}
                          category          = "registration"
                          businesscategory  = {queryParams.get("bc")}
                          businessCategories  = {businessCategories}
                        />   

                        <ConfirmationStep 
                          currentStep       = {step}
                          languages         = {languages}
                          locationData      = {locationDatas}
                          localStorageDatas = {localStorageDatas}
                          isRenewalPage       = {false}
                          goNextStep        = {goNextStep}
                          stepNo            = {10}
                          isQBR             = {Helper.isQbr(locationDatas)}
                          // termsLink={TERMS_CONDITIONS_LINK}
                          category          = "registration"
                          couponObj         = {couponData}
                          isUserLogged      = {isUserLogged}
                          businessCategories = {businessCategories}
                        />  
                          
                        <ExploreStep 
                          languages={languages}
                          currentStep       = {step}
                          isQBR             = {Helper.isQbr(locationDatas)}
                          isRenewalPage       = {false}
                          localStorageDatas = {localStorageDatas}
                          goNextStep        = {goNextStep}
                          stepNo            = {11}
                        />  
                      </div>

                      {step === 11 ? null :
                        <StickyFooter 
                          isProcessing                    = {isProcessing}
                          goNextStep                      = {goNextStep}
                          confirmOrder                    = {confirmOrder}
                          storeMembershipData             = {storeMembershipData}
                          currentStep                     = {step}
                          products                        = {products} //[Primary] 
                          secondaryProducts               = {secondaryProducts} // [Secondary]
                          declinedSecondaryMembership     = {declinedSecondaryMembership} // [Secondary]
                          checkBoxTerms                   = {checkBoxTerms} // [Step] - Review
                          reviewLoading                   = {reviewLoading} // [Step] - Review
                          checkBoxTermsQBR                = {checkBoxTermsQBR} // [Step] - Review
                          QBRLoading                      = {QBRLoading}
                          confirmValidateQBR              = {confirmValidateQBR}
                          validateQbr                     = {validateQbr}
                          memberStatus                    = {memberStatus} // [Step] - Personal Details
                          personalDetailsSubmit           = {personalDetailsSubmit} // [Step] Personal 
                          secondaryPersonalDetailsSubmit  = {secondaryPersonalDetailsSubmit}
                          onMouseHover                    = {onMouseHover}
                          onMouseLeave                    = {onMouseLeave}
                          onSubmitAddressDetails          = {onSubmitAddressDetails} // [Step] Primary Address
                          onSubmitSecondaryAddressDetails = {onSubmitSecondaryAddressDetails} // [Step] Secondary Address
                          languages                       = {languages}
                        />}
                  </div>
              </div>
          </div>
          <CTA 
            onCloseModal={onCloseModal}
            showModal={showModal}
            languages={languages}
          />
        </>
      );
  }  
}


export default App;

